/*******************************************
* 本JS檔存放位置由 WFU BLOG 提供
*
* JS檔主程式出自新同文堂：http://tongwen.openfoundry.org/
* 消息來源：http://hi.baidu.com/%CE%B5%C7%E5%D4%C2/blog/item/bf6b79d31fc49b289a5027ed.html
* 欲編輯、修改本程式，記得儲存的格式要選 unicode。
*
* WFU Blog : http://wayne-fu.blogspot.com/
*
***********************************/
/*** 此 JS 檔經過修改 (https://github.com/mollykannn/translate-big5-gbk.git) ***/

if (typeof(TongWen) == "undefined") var TongWen = new Object();

TongWen.t_2_s = {
"\u00af":"\u02c9",
"\u2025":"\u00a8",
"\u2027":"\u00b7",
"\u2035":"\uff40",
"\u2252":"\u2248",
"\u2266":"\u2264",
"\u2267":"\u2265",
"\u2571":"\uff0f",
"\u2572":"\uff3c",
"\u2574":"\uff3f",
"\u300c":"\u201c",
"\u300d":"\u201d",
"\u300e":"\u2018",
"\u300f":"\u2019",
"\u3473":"\u3447",
"\u361a":"\u360e",
"\u396e":"\u3918",
"\u3a73":"\u39d0",
"\u43b1":"\u43ac",
"\u4661":"\u464c",
"\u477c":"\u478d",
"\u4947":"\u4982",
"\u499b":"\u49b6",
"\u499f":"\u49b7",
"\u4c77":"\u4ca3",
"\u4e1f":"\u4e22",
"\u4e26":"\u5e76",
"\u4e3c":"\u4e95",
"\u4e7e":"\u5e72",
"\u4e82":"\u4e71",
"\u4e99":"\u4e98",
"\u4e9e":"\u4e9a",
"\u4f15":"\u592b",
"\u4f47":"\u4f2b",
"\u4f48":"\u5e03",
"\u4f54":"\u5360",
"\u4f6a":"\u5f8a",
"\u4f75":"\u5e76",
"\u4f86":"\u6765",
"\u4f96":"\u4ed1",
"\u4f9a":"\u5f87",
"\u4fb6":"\u4fa3",
"\u4fb7":"\u5c40",
"\u4fc1":"\u4fe3",
"\u4fc2":"\u7cfb",
"\u4fe0":"\u4fa0",
"\u5000":"\u4f25",
"\u5006":"\u4fe9",
"\u5009":"\u4ed3",
"\u500b":"\u4e2a",
"\u5011":"\u4eec",
"\u5016":"\u5e78",
"\u5023":"\u4eff",
"\u502b":"\u4f26",
"\u5049":"\u4f1f",
"\u506a":"\u903c",
"\u5074":"\u4fa7",
"\u5075":"\u4fa6",
"\u507a":"\u54b1",
"\u507d":"\u4f2a",
"\u5091":"\u6770",
"\u5096":"\u4f27",
"\u5098":"\u4f1e",
"\u5099":"\u5907",
"\u509a":"\u6548",
"\u50a2":"\u5bb6",
"\u50ad":"\u4f63",
"\u50af":"\u506c",
"\u50b3":"\u4f20",
"\u50b4":"\u4f1b",
"\u50b5":"\u503a",
"\u50b7":"\u4f24",
"\u50be":"\u503e",
"\u50c2":"\u507b",
"\u50c5":"\u4ec5",
"\u50c9":"\u4f65",
"\u50ca":"\u4ed9",
"\u50d1":"\u4fa8",
"\u50d5":"\u4ec6",
"\u50de":"\u4f2a",
"\u50e3":"\u50ed",
"\u50e5":"\u4fa5",
"\u50e8":"\u507e",
"\u50f1":"\u96c7",
"\u50f9":"\u4ef7",
"\u5100":"\u4eea",
"\u5102":"\u4fac",
"\u5104":"\u4ebf",
"\u5105":"\u5f53",
"\u5108":"\u4fa9",
"\u5109":"\u4fed",
"\u5110":"\u50a7",
"\u5114":"\u4fe6",
"\u5115":"\u4faa",
"\u5118":"\u5c3d",
"\u511f":"\u507f",
"\u512a":"\u4f18",
"\u5132":"\u50a8",
"\u5137":"\u4fea",
"\u5138":"\u7f57",
"\u513a":"\u50a9",
"\u513b":"\u50a5",
"\u513c":"\u4fe8",
"\u5147":"\u51f6",
"\u514c":"\u5151",
"\u5152":"\u513f",
"\u5157":"\u5156",
"\u5167":"\u5185",
"\u5169":"\u4e24",
"\u518a":"\u518c",
"\u5191":"\u80c4",
"\u51aa":"\u5e42",
"\u51c5":"\u6db8",
"\u51c8":"\u51c0",
"\u51cd":"\u51bb",
"\u51dc":"\u51db",
"\u51f1":"\u51ef",
"\u5225":"\u522b",
"\u522a":"\u5220",
"\u5244":"\u522d",
"\u5247":"\u5219",
"\u5249":"\u9509",
"\u524b":"\u514b",
"\u524e":"\u5239",
"\u5257":"\u522c",
"\u525b":"\u521a",
"\u525d":"\u5265",
"\u526e":"\u5250",
"\u5274":"\u5240",
"\u5275":"\u521b",
"\u5277":"\u94f2",
"\u5283":"\u5212",
"\u5284":"\u672d",
"\u5287":"\u5267",
"\u5289":"\u5218",
"\u528a":"\u523d",
"\u528c":"\u523f",
"\u528d":"\u5251",
"\u5291":"\u5242",
"\u52bb":"\u5321",
"\u52c1":"\u52b2",
"\u52d5":"\u52a8",
"\u52d7":"\u52d6",
"\u52d9":"\u52a1",
"\u52db":"\u52cb",
"\u52dd":"\u80dc",
"\u52de":"\u52b3",
"\u52e2":"\u52bf",
"\u52e3":"\u7ee9",
"\u52e6":"\u527f",
"\u52e9":"\u52da",
"\u52f1":"\u52a2",
"\u52f3":"\u52cb",
"\u52f5":"\u52b1",
"\u52f8":"\u529d",
"\u52fb":"\u5300",
"\u530b":"\u9676",
"\u532d":"\u5326",
"\u532f":"\u6c47",
"\u5331":"\u532e",
"\u5340":"\u533a",
"\u5344":"\u5eff",
"\u5354":"\u534f",
"\u536c":"\u6602",
"\u5379":"\u6064",
"\u537b":"\u5374",
"\u5399":"\u538d",
"\u53ad":"\u538c",
"\u53b2":"\u5389",
"\u53b4":"\u53a3",
"\u53c3":"\u53c2",
"\u53e1":"\u777f",
"\u53e2":"\u4e1b",
"\u540b":"\u5bf8",
"\u540e":"\u540e",
"\u5433":"\u5434",
"\u5436":"\u5450",
"\u5442":"\u5415",
"\u544e":"\u5c3a",
"\u54b7":"\u5555",
"\u54bc":"\u5459",
"\u54e1":"\u5458",
"\u5504":"\u5457",
"\u551d":"\u55ca",
"\u5538":"\u5ff5",
"\u554f":"\u95ee",
"\u5553":"\u542f",
"\u5557":"\u5556",
"\u555e":"\u54d1",
"\u555f":"\u542f",
"\u5562":"\u5521",
"\u5563":"\u8854",
"\u558e":"\u359e",
"\u559a":"\u5524",
"\u55aa":"\u4e27",
"\u55ab":"\u5403",
"\u55ac":"\u4e54",
"\u55ae":"\u5355",
"\u55b2":"\u54df",
"\u55c6":"\u545b",
"\u55c7":"\u556c",
"\u55ce":"\u5417",
"\u55da":"\u545c",
"\u55e9":"\u5522",
"\u55f6":"\u54d4",
"\u5606":"\u53f9",
"\u560d":"\u55bd",
"\u5614":"\u5455",
"\u5616":"\u5567",
"\u5617":"\u5c1d",
"\u561c":"\u551b",
"\u5629":"\u54d7",
"\u562e":"\u5520",
"\u562f":"\u5578",
"\u5630":"\u53fd",
"\u5635":"\u54d3",
"\u5638":"\u5452",
"\u5641":"\u6076",
"\u5653":"\u5618",
"\u565d":"\u549d",
"\u5660":"\u54d2",
"\u5665":"\u54dd",
"\u5666":"\u54d5",
"\u566f":"\u55f3",
"\u5672":"\u54d9",
"\u5674":"\u55b7",
"\u5678":"\u5428",
"\u5679":"\u5f53",
"\u5680":"\u549b",
"\u5687":"\u5413",
"\u568c":"\u54dc",
"\u5690":"\u5c1d",
"\u5695":"\u565c",
"\u5699":"\u556e",
"\u56a5":"\u54bd",
"\u56a6":"\u5456",
"\u56a8":"\u5499",
"\u56ae":"\u5411",
"\u56b3":"\u55be",
"\u56b4":"\u4e25",
"\u56b6":"\u5624",
"\u56c0":"\u556d",
"\u56c1":"\u55eb",
"\u56c2":"\u56a3",
"\u56c5":"\u5181",
"\u56c8":"\u5453",
"\u56c9":"\u5570",
"\u56cc":"\u82cf",
"\u56d1":"\u5631",
"\u56d3":"\u556e",
"\u56ea":"\u56f1",
"\u5707":"\u56f5",
"\u570b":"\u56fd",
"\u570d":"\u56f4",
"\u570f":"\u5708",
"\u5712":"\u56ed",
"\u5713":"\u5706",
"\u5716":"\u56fe",
"\u5718":"\u56e2",
"\u5775":"\u4e18",
"\u57dc":"\u91ce",
"\u57e1":"\u57ad",
"\u57f7":"\u6267",
"\u57fc":"\u5d0e",
"\u5805":"\u575a",
"\u580a":"\u57a9",
"\u5816":"\u57b4",
"\u581d":"\u57da",
"\u582f":"\u5c27",
"\u5831":"\u62a5",
"\u5834":"\u573a",
"\u584a":"\u5757",
"\u584b":"\u8314",
"\u584f":"\u57b2",
"\u5852":"\u57d8",
"\u5857":"\u6d82",
"\u585a":"\u51a2",
"\u5862":"\u575e",
"\u5864":"\u57d9",
"\u5875":"\u5c18",
"\u5879":"\u5811",
"\u588a":"\u57ab",
"\u5891":"\u5892",
"\u589c":"\u5760",
"\u58ab":"\u6a3d",
"\u58ae":"\u5815",
"\u58b3":"\u575f",
"\u58bb":"\u5899",
"\u58be":"\u57a6",
"\u58c7":"\u575b",
"\u58ce":"\u57d9",
"\u58d3":"\u538b",
"\u58d8":"\u5792",
"\u58d9":"\u5739",
"\u58da":"\u5786",
"\u58de":"\u574f",
"\u58df":"\u5784",
"\u58e2":"\u575c",
"\u58e9":"\u575d",
"\u58ef":"\u58ee",
"\u58fa":"\u58f6",
"\u58fd":"\u5bff",
"\u5920":"\u591f",
"\u5922":"\u68a6",
"\u593e":"\u5939",
"\u5950":"\u5942",
"\u5967":"\u5965",
"\u5969":"\u5941",
"\u596a":"\u593a",
"\u596e":"\u594b",
"\u599d":"\u5986",
"\u59cd":"\u59d7",
"\u59e6":"\u5978",
"\u59ea":"\u4f84",
"\u5a1b":"\u5a31",
"\u5a41":"\u5a04",
"\u5a66":"\u5987",
"\u5a6c":"\u6deb",
"\u5a6d":"\u5a05",
"\u5aa7":"\u5a32",
"\u5aae":"\u5077",
"\u5aaf":"\u59ab",
"\u5abc":"\u5aaa",
"\u5abd":"\u5988",
"\u5abf":"\u6127",
"\u5acb":"\u8885",
"\u5ad7":"\u59aa",
"\u5af5":"\u59a9",
"\u5afb":"\u5a34",
"\u5aff":"\u5a73",
"\u5b08":"\u5a06",
"\u5b0b":"\u5a75",
"\u5b0c":"\u5a07",
"\u5b19":"\u5af1",
"\u5b1d":"\u8885",
"\u5b21":"\u5ad2",
"\u5b24":"\u5b37",
"\u5b2a":"\u5ad4",
"\u5b2d":"\u5976",
"\u5b30":"\u5a74",
"\u5b38":"\u5a76",
"\u5b43":"\u5a18",
"\u5b4c":"\u5a08",
"\u5b6b":"\u5b59",
"\u5b78":"\u5b66",
"\u5b7f":"\u5b6a",
"\u5bae":"\u5bab",
"\u5bd8":"\u7f6e",
"\u5be2":"\u5bdd",
"\u5be6":"\u5b9e",
"\u5be7":"\u5b81",
"\u5be9":"\u5ba1",
"\u5beb":"\u5199",
"\u5bec":"\u5bbd",
"\u5bf5":"\u5ba0",
"\u5bf6":"\u5b9d",
"\u5c07":"\u5c06",
"\u5c08":"\u4e13",
"\u5c0b":"\u5bfb",
"\u5c0d":"\u5bf9",
"\u5c0e":"\u5bfc",
"\u5c37":"\u5c34",
"\u5c46":"\u5c4a",
"\u5c4d":"\u5c38",
"\u5c5c":"\u5c49",
"\u5c5d":"\u6249",
"\u5c62":"\u5c61",
"\u5c64":"\u5c42",
"\u5c68":"\u5c66",
"\u5c6c":"\u5c5e",
"\u5ca1":"\u5188",
"\u5cf4":"\u5c98",
"\u5cf6":"\u5c9b",
"\u5cfd":"\u5ce1",
"\u5d0d":"\u5d03",
"\u5d11":"\u6606",
"\u5d17":"\u5c97",
"\u5d19":"\u4ed1",
"\u5d20":"\u5cbd",
"\u5d22":"\u5ce5",
"\u5d33":"\u5d5b",
"\u5d50":"\u5c9a",
"\u5d52":"\u5ca9",
"\u5d81":"\u5d5d",
"\u5d84":"\u5d2d",
"\u5d87":"\u5c96",
"\u5d94":"\u5d5a",
"\u5d97":"\u5d02",
"\u5da0":"\u5ce4",
"\u5da2":"\u5ce3",
"\u5da7":"\u5cc4",
"\u5da8":"\u5cc3",
"\u5db8":"\u5d58",
"\u5dba":"\u5cad",
"\u5dbc":"\u5c7f",
"\u5dbd":"\u5cb3",
"\u5dcb":"\u5cbf",
"\u5dd2":"\u5ce6",
"\u5dd4":"\u5dc5",
"\u5dd6":"\u5ca9",
"\u5df0":"\u5def",
"\u5df9":"\u537a",
"\u5e25":"\u5e05",
"\u5e2b":"\u5e08",
"\u5e33":"\u5e10",
"\u5e36":"\u5e26",
"\u5e40":"\u5e27",
"\u5e43":"\u5e0f",
"\u5e57":"\u5e3c",
"\u5e58":"\u5e3b",
"\u5e5f":"\u5e1c",
"\u5e63":"\u5e01",
"\u5e6b":"\u5e2e",
"\u5e6c":"\u5e31",
"\u5e75":"\u5f00",
"\u5e77":"\u5e76",
"\u5e79":"\u5e72",
"\u5e7e":"\u51e0",
"\u5e82":"\u4ec4",
"\u5eab":"\u5e93",
"\u5ec1":"\u5395",
"\u5ec2":"\u53a2",
"\u5ec4":"\u53a9",
"\u5ec8":"\u53a6",
"\u5ece":"\u5ebc",
"\u5eda":"\u53a8",
"\u5edd":"\u53ae",
"\u5edf":"\u5e99",
"\u5ee0":"\u5382",
"\u5ee1":"\u5e91",
"\u5ee2":"\u5e9f",
"\u5ee3":"\u5e7f",
"\u5ee9":"\u5eea",
"\u5eec":"\u5e90",
"\u5ef1":"\u75c8",
"\u5ef3":"\u5385",
"\u5f12":"\u5f11",
"\u5f14":"\u540a",
"\u5f33":"\u5f2a",
"\u5f35":"\u5f20",
"\u5f37":"\u5f3a",
"\u5f46":"\u522b",
"\u5f48":"\u5f39",
"\u5f4c":"\u5f25",
"\u5f4e":"\u5f2f",
"\u5f59":"\u6c47",
"\u5f5a":"\u6c47",
"\u5f65":"\u5f66",
"\u5f6b":"\u96d5",
"\u5f7f":"\u4f5b",
"\u5f8c":"\u540e",
"\u5f91":"\u5f84",
"\u5f9e":"\u4ece",
"\u5fa0":"\u5f95",
"\u5fa9":"\u590d",
"\u5fac":"\u65c1",
"\u5fb5":"\u5f81",
"\u5fb9":"\u5f7b",
"\u6046":"\u6052",
"\u6065":"\u803b",
"\u6085":"\u60a6",
"\u60b5":"\u6005",
"\u60b6":"\u95f7",
"\u60bd":"\u51c4",
"\u60c7":"\u6566",
"\u60e1":"\u6076",
"\u60f1":"\u607c",
"\u60f2":"\u607d",
"\u60f7":"\u8822",
"\u60fb":"\u607b",
"\u611b":"\u7231",
"\u611c":"\u60ec",
"\u6128":"\u60ab",
"\u6134":"\u6006",
"\u6137":"\u607a",
"\u613e":"\u5ffe",
"\u6144":"\u6817",
"\u6147":"\u6bb7",
"\u614b":"\u6001",
"\u614d":"\u6120",
"\u6158":"\u60e8",
"\u615a":"\u60ed",
"\u615f":"\u6078",
"\u6163":"\u60ef",
"\u616a":"\u6004",
"\u616b":"\u6002",
"\u616e":"\u8651",
"\u6173":"\u60ad",
"\u6176":"\u5e86",
"\u617c":"\u621a",
"\u617e":"\u6b32",
"\u6182":"\u5fe7",
"\u618a":"\u60eb",
"\u6190":"\u601c",
"\u6191":"\u51ed",
"\u6192":"\u6126",
"\u619a":"\u60ee",
"\u61a4":"\u6124",
"\u61ab":"\u60af",
"\u61ae":"\u6003",
"\u61b2":"\u5baa",
"\u61b6":"\u5fc6",
"\u61c3":"\u52e4",
"\u61c7":"\u6073",
"\u61c9":"\u5e94",
"\u61cc":"\u603f",
"\u61cd":"\u61d4",
"\u61de":"\u8499",
"\u61df":"\u603c",
"\u61e3":"\u61d1",
"\u61e8":"\u6079",
"\u61f2":"\u60e9",
"\u61f6":"\u61d2",
"\u61f7":"\u6000",
"\u61f8":"\u60ac",
"\u61fa":"\u5fcf",
"\u61fc":"\u60e7",
"\u61fe":"\u6151",
"\u6200":"\u604b",
"\u6207":"\u6206",
"\u6209":"\u94ba",
"\u6214":"\u620b",
"\u6227":"\u6217",
"\u6229":"\u622c",
"\u6230":"\u6218",
"\u6232":"\u620f",
"\u6236":"\u6237",
"\u6250":"\u4ec2",
"\u625e":"\u634d",
"\u6271":"\u63d2",
"\u627a":"\u62b5",
"\u6283":"\u62da",
"\u6294":"\u62b1",
"\u62b4":"\u66f3",
"\u62cb":"\u629b",
"\u62d1":"\u94b3",
"\u630c":"\u683c",
"\u6336":"\u5c40",
"\u633e":"\u631f",
"\u6368":"\u820d",
"\u636b":"\u626a",
"\u6372":"\u5377",
"\u6383":"\u626b",
"\u6384":"\u62a1",
"\u6386":"\u39cf",
"\u6397":"\u631c",
"\u6399":"\u6323",
"\u639b":"\u6302",
"\u63a1":"\u91c7",
"\u63c0":"\u62e3",
"\u63da":"\u626c",
"\u63db":"\u6362",
"\u63ee":"\u6325",
"\u63f9":"\u80cc",
"\u6406":"\u6784",
"\u640d":"\u635f",
"\u6416":"\u6447",
"\u6417":"\u6363",
"\u641f":"\u64c0",
"\u6425":"\u6376",
"\u6428":"\u6253",
"\u642f":"\u638f",
"\u6436":"\u62a2",
"\u643e":"\u69a8",
"\u6440":"\u6342",
"\u6443":"\u625b",
"\u6451":"\u63b4",
"\u645c":"\u63bc",
"\u645f":"\u6402",
"\u646f":"\u631a",
"\u6473":"\u62a0",
"\u6476":"\u629f",
"\u647b":"\u63ba",
"\u6488":"\u635e",
"\u648f":"\u6326",
"\u6490":"\u6491",
"\u6493":"\u6320",
"\u649a":"\u62c8",
"\u649f":"\u6322",
"\u64a2":"\u63b8",
"\u64a3":"\u63b8",
"\u64a5":"\u62e8",
"\u64a6":"\u626f",
"\u64ab":"\u629a",
"\u64b2":"\u6251",
"\u64b3":"\u63ff",
"\u64bb":"\u631e",
"\u64be":"\u631d",
"\u64bf":"\u6361",
"\u64c1":"\u62e5",
"\u64c4":"\u63b3",
"\u64c7":"\u62e9",
"\u64ca":"\u51fb",
"\u64cb":"\u6321",
"\u64d3":"\u39df",
"\u64d4":"\u62c5",
"\u64da":"\u636e",
"\u64e0":"\u6324",
"\u64e1":"\u62ac",
"\u64e3":"\u6363",
"\u64ec":"\u62df",
"\u64ef":"\u6448",
"\u64f0":"\u62e7",
"\u64f1":"\u6401",
"\u64f2":"\u63b7",
"\u64f4":"\u6269",
"\u64f7":"\u64b7",
"\u64fa":"\u6446",
"\u64fb":"\u64de",
"\u64fc":"\u64b8",
"\u64fe":"\u6270",
"\u6504":"\u6445",
"\u6506":"\u64b5",
"\u650f":"\u62e2",
"\u6514":"\u62e6",
"\u6516":"\u6484",
"\u6519":"\u6400",
"\u651b":"\u64ba",
"\u651c":"\u643a",
"\u651d":"\u6444",
"\u6522":"\u6512",
"\u6523":"\u631b",
"\u6524":"\u644a",
"\u652a":"\u6405",
"\u652c":"\u63fd",
"\u6537":"\u8003",
"\u6557":"\u8d25",
"\u6558":"\u53d9",
"\u6575":"\u654c",
"\u6578":"\u6570",
"\u6582":"\u655b",
"\u6583":"\u6bd9",
"\u6595":"\u6593",
"\u65ac":"\u65a9",
"\u65b7":"\u65ad",
"\u65bc":"\u4e8e",
"\u65c2":"\u65d7",
"\u65db":"\u5e61",
"\u6607":"\u5347",
"\u6642":"\u65f6",
"\u6649":"\u664b",
"\u665d":"\u663c",
"\u665e":"\u66e6",
"\u6662":"\u6670",
"\u6673":"\u6670",
"\u667b":"\u6697",
"\u6688":"\u6655",
"\u6689":"\u6656",
"\u6698":"\u9633",
"\u66a2":"\u7545",
"\u66ab":"\u6682",
"\u66b1":"\u6635",
"\u66b8":"\u4e86",
"\u66c4":"\u6654",
"\u66c6":"\u5386",
"\u66c7":"\u6619",
"\u66c9":"\u6653",
"\u66cf":"\u5411",
"\u66d6":"\u66a7",
"\u66e0":"\u65f7",
"\u66e8":"\u663d",
"\u66ec":"\u6652",
"\u66f8":"\u4e66",
"\u6703":"\u4f1a",
"\u6722":"\u671b",
"\u6727":"\u80e7",
"\u672e":"\u672f",
"\u6747":"\u572c",
"\u6771":"\u4e1c",
"\u67b4":"\u62d0",
"\u67f5":"\u6805",
"\u67fa":"\u62d0",
"\u6812":"\u65ec",
"\u686e":"\u676f",
"\u687f":"\u6746",
"\u6894":"\u6800",
"\u6898":"\u67a7",
"\u689d":"\u6761",
"\u689f":"\u67ad",
"\u68b1":"\u6346",
"\u68c4":"\u5f03",
"\u68d6":"\u67a8",
"\u68d7":"\u67a3",
"\u68df":"\u680b",
"\u68e1":"\u3b4e",
"\u68e7":"\u6808",
"\u68f2":"\u6816",
"\u690f":"\u6860",
"\u6944":"\u533e",
"\u694a":"\u6768",
"\u6953":"\u67ab",
"\u6959":"\u8302",
"\u695c":"\u80e1",
"\u6968":"\u6862",
"\u696d":"\u4e1a",
"\u6975":"\u6781",
"\u69a6":"\u5e72",
"\u69aa":"\u6769",
"\u69ae":"\u8363",
"\u69bf":"\u6864",
"\u69c3":"\u76d8",
"\u69cb":"\u6784",
"\u69cd":"\u67aa",
"\u69d3":"\u6760",
"\u69e7":"\u6920",
"\u69e8":"\u6901",
"\u69f3":"\u6868",
"\u6a01":"\u6869",
"\u6a02":"\u4e50",
"\u6a05":"\u679e",
"\u6a11":"\u6881",
"\u6a13":"\u697c",
"\u6a19":"\u6807",
"\u6a1e":"\u67a2",
"\u6a23":"\u6837",
"\u6a38":"\u6734",
"\u6a39":"\u6811",
"\u6a3a":"\u6866",
"\u6a48":"\u6861",
"\u6a4b":"\u6865",
"\u6a5f":"\u673a",
"\u6a62":"\u692d",
"\u6a66":"\u5e62",
"\u6a6b":"\u6a2a",
"\u6a81":"\u6aa9",
"\u6a89":"\u67fd",
"\u6a94":"\u6863",
"\u6a9c":"\u6867",
"\u6a9f":"\u69da",
"\u6aa2":"\u68c0",
"\u6aa3":"\u6a2f",
"\u6aaf":"\u53f0",
"\u6ab3":"\u69df",
"\u6ab8":"\u67e0",
"\u6abb":"\u69db",
"\u6ac2":"\u68f9",
"\u6ac3":"\u67dc",
"\u6ad0":"\u7d2f",
"\u6ad3":"\u6a79",
"\u6ada":"\u6988",
"\u6adb":"\u6809",
"\u6add":"\u691f",
"\u6ade":"\u6a7c",
"\u6adf":"\u680e",
"\u6ae5":"\u6a71",
"\u6ae7":"\u69e0",
"\u6ae8":"\u680c",
"\u6aea":"\u67a5",
"\u6aeb":"\u6a65",
"\u6aec":"\u6987",
"\u6af3":"\u680a",
"\u6af8":"\u6989",
"\u6afa":"\u68c2",
"\u6afb":"\u6a31",
"\u6b04":"\u680f",
"\u6b0a":"\u6743",
"\u6b0f":"\u6924",
"\u6b12":"\u683e",
"\u6b16":"\u6984",
"\u6b1e":"\u68c2",
"\u6b38":"\u5509",
"\u6b3d":"\u94a6",
"\u6b4e":"\u53f9",
"\u6b50":"\u6b27",
"\u6b5f":"\u6b24",
"\u6b61":"\u6b22",
"\u6b72":"\u5c81",
"\u6b77":"\u5386",
"\u6b78":"\u5f52",
"\u6b7f":"\u6b81",
"\u6b80":"\u592d",
"\u6b98":"\u6b8b",
"\u6b9e":"\u6b92",
"\u6ba4":"\u6b87",
"\u6bab":"\u6b9a",
"\u6bad":"\u50f5",
"\u6bae":"\u6b93",
"\u6baf":"\u6ba1",
"\u6bb2":"\u6b7c",
"\u6bba":"\u6740",
"\u6bbc":"\u58f3",
"\u6bbd":"\u80b4",
"\u6bc0":"\u6bc1",
"\u6bc6":"\u6bb4",
"\u6bcc":"\u6bcb",
"\u6bd8":"\u6bd7",
"\u6bec":"\u7403",
"\u6bff":"\u6bf5",
"\u6c08":"\u6be1",
"\u6c0c":"\u6c07",
"\u6c23":"\u6c14",
"\u6c2b":"\u6c22",
"\u6c2c":"\u6c29",
"\u6c33":"\u6c32",
"\u6c3e":"\u6cdb",
"\u6c4d":"\u4e38",
"\u6c4e":"\u6cdb",
"\u6c59":"\u6c61",
"\u6c7a":"\u51b3",
"\u6c8d":"\u51b1",
"\u6c92":"\u6ca1",
"\u6c96":"\u51b2",
"\u6cc1":"\u51b5",
"\u6cdd":"\u6eaf",
"\u6d1f":"\u6d95",
"\u6d29":"\u6cc4",
"\u6d36":"\u6c79",
"\u6d6c":"\u91cc",
"\u6d79":"\u6d43",
"\u6d87":"\u6cfe",
"\u6dbc":"\u51c9",
"\u6dd2":"\u51c4",
"\u6dda":"\u6cea",
"\u6de5":"\u6e0c",
"\u6de8":"\u51c0",
"\u6dea":"\u6ca6",
"\u6df5":"\u6e0a",
"\u6df6":"\u6d9e",
"\u6dfa":"\u6d45",
"\u6e19":"\u6da3",
"\u6e1b":"\u51cf",
"\u6e22":"\u6ca8",
"\u6e26":"\u6da1",
"\u6e2c":"\u6d4b",
"\u6e3e":"\u6d51",
"\u6e4a":"\u51d1",
"\u6e5e":"\u6d48",
"\u6e63":"\u95f5",
"\u6e67":"\u6d8c",
"\u6e6f":"\u6c64",
"\u6e88":"\u6ca9",
"\u6e96":"\u51c6",
"\u6e9d":"\u6c9f",
"\u6eab":"\u6e29",
"\u6eae":"\u6d49",
"\u6eb3":"\u6da2",
"\u6ebc":"\u6e7f",
"\u6ec4":"\u6ca7",
"\u6ec5":"\u706d",
"\u6ecc":"\u6da4",
"\u6ece":"\u8365",
"\u6eec":"\u6caa",
"\u6eef":"\u6ede",
"\u6ef2":"\u6e17",
"\u6ef7":"\u5364",
"\u6ef8":"\u6d52",
"\u6efb":"\u6d50",
"\u6efe":"\u6eda",
"\u6eff":"\u6ee1",
"\u6f01":"\u6e14",
"\u6f0a":"\u6e87",
"\u6f1a":"\u6ca4",
"\u6f22":"\u6c49",
"\u6f23":"\u6d9f",
"\u6f2c":"\u6e0d",
"\u6f32":"\u6da8",
"\u6f35":"\u6e86",
"\u6f38":"\u6e10",
"\u6f3f":"\u6d46",
"\u6f41":"\u988d",
"\u6f51":"\u6cfc",
"\u6f54":"\u6d01",
"\u6f5b":"\u6f5c",
"\u6f5f":"\u8204",
"\u6f64":"\u6da6",
"\u6f6f":"\u6d54",
"\u6f70":"\u6e83",
"\u6f77":"\u6ed7",
"\u6f7f":"\u6da0",
"\u6f80":"\u6da9",
"\u6f82":"\u6f84",
"\u6f86":"\u6d47",
"\u6f87":"\u6d9d",
"\u6f94":"\u6d69",
"\u6f97":"\u6da7",
"\u6fa0":"\u6e11",
"\u6fa4":"\u6cfd",
"\u6fa6":"\u6eea",
"\u6fa9":"\u6cf6",
"\u6fae":"\u6d4d",
"\u6fb1":"\u6dc0",
"\u6fbe":"\u3ce0",
"\u6fc1":"\u6d4a",
"\u6fc3":"\u6d53",
"\u6fd5":"\u6e7f",
"\u6fd8":"\u6cde",
"\u6fdb":"\u8499",
"\u6fdc":"\u6d55",
"\u6fdf":"\u6d4e",
"\u6fe4":"\u6d9b",
"\u6feb":"\u6ee5",
"\u6fec":"\u6d5a",
"\u6ff0":"\u6f4d",
"\u6ff1":"\u6ee8",
"\u6ffa":"\u6e85",
"\u6ffc":"\u6cfa",
"\u6ffe":"\u6ee4",
"\u7001":"\u6f3e",
"\u7005":"\u6ee2",
"\u7006":"\u6e0e",
"\u7009":"\u6cfb",
"\u700b":"\u6c88",
"\u700f":"\u6d4f",
"\u7015":"\u6fd2",
"\u7018":"\u6cf8",
"\u701d":"\u6ca5",
"\u701f":"\u6f47",
"\u7020":"\u6f46",
"\u7026":"\u6f74",
"\u7027":"\u6cf7",
"\u7028":"\u6fd1",
"\u7030":"\u5f25",
"\u7032":"\u6f4b",
"\u703e":"\u6f9c",
"\u7043":"\u6ca3",
"\u7044":"\u6ee0",
"\u7051":"\u6d12",
"\u7055":"\u6f13",
"\u7058":"\u6ee9",
"\u705d":"\u704f",
"\u7063":"\u6e7e",
"\u7064":"\u6ee6",
"\u7069":"\u6edf",
"\u707d":"\u707e",
"\u70a4":"\u7167",
"\u70b0":"\u70ae",
"\u70ba":"\u4e3a",
"\u70cf":"\u4e4c",
"\u70f4":"\u70c3",
"\u7121":"\u65e0",
"\u7149":"\u70bc",
"\u7152":"\u709c",
"\u7156":"\u6696",
"\u7159":"\u70df",
"\u7162":"\u8315",
"\u7165":"\u7115",
"\u7169":"\u70e6",
"\u716c":"\u7080",
"\u7192":"\u8367",
"\u7197":"\u709d",
"\u71b1":"\u70ed",
"\u71be":"\u70bd",
"\u71c1":"\u70e8",
"\u71c4":"\u7130",
"\u71c8":"\u706f",
"\u71c9":"\u7096",
"\u71d0":"\u78f7",
"\u71d2":"\u70e7",
"\u71d9":"\u70eb",
"\u71dc":"\u7116",
"\u71df":"\u8425",
"\u71e6":"\u707f",
"\u71ec":"\u6bc1",
"\u71ed":"\u70db",
"\u71f4":"\u70e9",
"\u71fb":"\u718f",
"\u71fc":"\u70ec",
"\u71fe":"\u7118",
"\u71ff":"\u8000",
"\u720d":"\u70c1",
"\u7210":"\u7089",
"\u721b":"\u70c2",
"\u722d":"\u4e89",
"\u7232":"\u4e3a",
"\u723a":"\u7237",
"\u723e":"\u5c14",
"\u7246":"\u5899",
"\u7258":"\u724d",
"\u7260":"\u5b83",
"\u7274":"\u62b5",
"\u727d":"\u7275",
"\u7296":"\u8366",
"\u729b":"\u7266",
"\u72a2":"\u728a",
"\u72a7":"\u727a",
"\u72c0":"\u72b6",
"\u72da":"\u65e6",
"\u72f9":"\u72ed",
"\u72fd":"\u72c8",
"\u7319":"\u72f0",
"\u7336":"\u72b9",
"\u733b":"\u72f2",
"\u7341":"\u72b8",
"\u7343":"\u5446",
"\u7344":"\u72f1",
"\u7345":"\u72ee",
"\u734e":"\u5956",
"\u7368":"\u72ec",
"\u736a":"\u72ef",
"\u736b":"\u7303",
"\u736e":"\u72dd",
"\u7370":"\u72de",
"\u7372":"\u83b7",
"\u7375":"\u730e",
"\u7377":"\u72b7",
"\u7378":"\u517d",
"\u737a":"\u736d",
"\u737b":"\u732e",
"\u737c":"\u7315",
"\u7380":"\u7321",
"\u7385":"\u5999",
"\u7386":"\u5179",
"\u73a8":"\u73cf",
"\u73ea":"\u572d",
"\u73ee":"\u4f69",
"\u73fe":"\u73b0",
"\u7431":"\u96d5",
"\u743a":"\u73d0",
"\u743f":"\u73f2",
"\u744b":"\u73ae",
"\u7463":"\u7410",
"\u7464":"\u7476",
"\u7469":"\u83b9",
"\u746a":"\u739b",
"\u746f":"\u7405",
"\u7472":"\u73b1",
"\u7489":"\u740f",
"\u74a1":"\u740e",
"\u74a3":"\u7391",
"\u74a6":"\u7477",
"\u74b0":"\u73af",
"\u74bd":"\u73ba",
"\u74bf":"\u7487",
"\u74ca":"\u743c",
"\u74cf":"\u73d1",
"\u74d4":"\u748e",
"\u74d6":"\u9576",
"\u74da":"\u74d2",
"\u750c":"\u74ef",
"\u7515":"\u74ee",
"\u7522":"\u4ea7",
"\u7523":"\u4ea7",
"\u7526":"\u82cf",
"\u752a":"\u89d2",
"\u755d":"\u4ea9",
"\u7562":"\u6bd5",
"\u756b":"\u753b",
"\u756c":"\u7572",
"\u7570":"\u5f02",
"\u7576":"\u5f53",
"\u7587":"\u7574",
"\u758a":"\u53e0",
"\u75bf":"\u75f1",
"\u75d9":"\u75c9",
"\u75e0":"\u9178",
"\u75f2":"\u9ebb",
"\u75f3":"\u9ebb",
"\u75fa":"\u75f9",
"\u75fe":"\u75b4",
"\u7602":"\u75d6",
"\u7609":"\u6108",
"\u760b":"\u75af",
"\u760d":"\u75a1",
"\u7613":"\u75ea",
"\u761e":"\u7617",
"\u7621":"\u75ae",
"\u7627":"\u759f",
"\u763a":"\u7618",
"\u763b":"\u7618",
"\u7642":"\u7597",
"\u7646":"\u75e8",
"\u7647":"\u75eb",
"\u7649":"\u7605",
"\u7652":"\u6108",
"\u7658":"\u75a0",
"\u765f":"\u762a",
"\u7661":"\u75f4",
"\u7662":"\u75d2",
"\u7664":"\u7596",
"\u7665":"\u75c7",
"\u7667":"\u75ac",
"\u7669":"\u765e",
"\u766c":"\u7663",
"\u766d":"\u763f",
"\u766e":"\u763e",
"\u7670":"\u75c8",
"\u7671":"\u762b",
"\u7672":"\u766b",
"\u767c":"\u53d1",
"\u7681":"\u7682",
"\u769a":"\u7691",
"\u76b0":"\u75b1",
"\u76b8":"\u76b2",
"\u76ba":"\u76b1",
"\u76c3":"\u676f",
"\u76dc":"\u76d7",
"\u76de":"\u76cf",
"\u76e1":"\u5c3d",
"\u76e3":"\u76d1",
"\u76e4":"\u76d8",
"\u76e7":"\u5362",
"\u76ea":"\u8361",
"\u7725":"\u7726",
"\u773e":"\u4f17",
"\u774f":"\u56f0",
"\u775c":"\u7741",
"\u775e":"\u7750",
"\u776a":"\u777e",
"\u7787":"\u772f",
"\u7798":"\u770d",
"\u779c":"\u4056",
"\u779e":"\u7792",
"\u77bc":"\u7751",
"\u77c7":"\u8499",
"\u77d3":"\u772c",
"\u77da":"\u77a9",
"\u77ef":"\u77eb",
"\u7832":"\u70ae",
"\u7843":"\u6731",
"\u7864":"\u7856",
"\u7868":"\u7817",
"\u786f":"\u781a",
"\u7895":"\u5d0e",
"\u78a9":"\u7855",
"\u78aa":"\u7827",
"\u78ad":"\u7800",
"\u78b8":"\u781c",
"\u78ba":"\u786e",
"\u78bc":"\u7801",
"\u78d1":"\u7859",
"\u78da":"\u7816",
"\u78e3":"\u789c",
"\u78e7":"\u789b",
"\u78ef":"\u77f6",
"\u78fd":"\u7857",
"\u7904":"\u785a",
"\u790e":"\u7840",
"\u7919":"\u788d",
"\u7926":"\u77ff",
"\u792a":"\u783a",
"\u792b":"\u783e",
"\u792c":"\u77fe",
"\u7931":"\u783b",
"\u7942":"\u4ed6",
"\u7945":"\u7946",
"\u7947":"\u53ea",
"\u7950":"\u4f51",
"\u797c":"\u88f8",
"\u797f":"\u7984",
"\u798d":"\u7978",
"\u798e":"\u796f",
"\u7995":"\u794e",
"\u79a6":"\u5fa1",
"\u79aa":"\u7985",
"\u79ae":"\u793c",
"\u79b1":"\u7977",
"\u79bf":"\u79c3",
"\u79c8":"\u7c7c",
"\u79cf":"\u8017",
"\u7a05":"\u7a0e",
"\u7a08":"\u79c6",
"\u7a1c":"\u68f1",
"\u7a1f":"\u7980",
"\u7a28":"\u6241",
"\u7a2e":"\u79cd",
"\u7a31":"\u79f0",
"\u7a40":"\u8c37",
"\u7a47":"\u415f",
"\u7a4c":"\u7a23",
"\u7a4d":"\u79ef",
"\u7a4e":"\u9896",
"\u7a61":"\u7a51",
"\u7a62":"\u79fd",
"\u7a68":"\u9893",
"\u7a69":"\u7a33",
"\u7a6b":"\u83b7",
"\u7aa9":"\u7a9d",
"\u7aaa":"\u6d3c",
"\u7aae":"\u7a77",
"\u7aaf":"\u7a91",
"\u7ab5":"\u7a8e",
"\u7ab6":"\u7aad",
"\u7aba":"\u7aa5",
"\u7ac4":"\u7a9c",
"\u7ac5":"\u7a8d",
"\u7ac7":"\u7aa6",
"\u7aca":"\u7a83",
"\u7af6":"\u7ade",
"\u7b3b":"\u7b47",
"\u7b46":"\u7b14",
"\u7b4d":"\u7b0b",
"\u7b67":"\u7b15",
"\u7b74":"\u7b56",
"\u7b84":"\u7b85",
"\u7b87":"\u4e2a",
"\u7b8b":"\u7b3a",
"\u7b8f":"\u7b5d",
"\u7ba0":"\u68f0",
"\u7bc0":"\u8282",
"\u7bc4":"\u8303",
"\u7bc9":"\u7b51",
"\u7bcb":"\u7ba7",
"\u7bdb":"\u7bac",
"\u7be0":"\u7b71",
"\u7be4":"\u7b03",
"\u7be9":"\u7b5b",
"\u7bf2":"\u5f57",
"\u7bf3":"\u7b5a",
"\u7c00":"\u7ba6",
"\u7c0d":"\u7bd3",
"\u7c11":"\u84d1",
"\u7c1e":"\u7baa",
"\u7c21":"\u7b80",
"\u7c23":"\u7bd1",
"\u7c2b":"\u7bab",
"\u7c37":"\u6a90",
"\u7c3d":"\u7b7e",
"\u7c3e":"\u5e18",
"\u7c43":"\u7bee",
"\u7c4c":"\u7b79",
"\u7c50":"\u85e4",
"\u7c59":"\u7b93",
"\u7c5c":"\u7ba8",
"\u7c5f":"\u7c41",
"\u7c60":"\u7b3c",
"\u7c64":"\u7b7e",
"\u7c65":"\u9fa0",
"\u7c69":"\u7b3e",
"\u7c6a":"\u7c16",
"\u7c6c":"\u7bf1",
"\u7c6e":"\u7ba9",
"\u7c72":"\u5401",
"\u7ca7":"\u5986",
"\u7cb5":"\u7ca4",
"\u7cdd":"\u7cc1",
"\u7cde":"\u7caa",
"\u7ce7":"\u7cae",
"\u7cf0":"\u56e2",
"\u7cf2":"\u7c9d",
"\u7cf4":"\u7c74",
"\u7cf6":"\u7c9c",
"\u7cfe":"\u7ea0",
"\u7d00":"\u7eaa",
"\u7d02":"\u7ea3",
"\u7d04":"\u7ea6",
"\u7d05":"\u7ea2",
"\u7d06":"\u7ea1",
"\u7d07":"\u7ea5",
"\u7d08":"\u7ea8",
"\u7d09":"\u7eab",
"\u7d0b":"\u7eb9",
"\u7d0d":"\u7eb3",
"\u7d10":"\u7ebd",
"\u7d13":"\u7ebe",
"\u7d14":"\u7eaf",
"\u7d15":"\u7eb0",
"\u7d16":"\u7ebc",
"\u7d17":"\u7eb1",
"\u7d18":"\u7eae",
"\u7d19":"\u7eb8",
"\u7d1a":"\u7ea7",
"\u7d1b":"\u7eb7",
"\u7d1c":"\u7ead",
"\u7d1d":"\u7eb4",
"\u7d21":"\u7eba",
"\u7d2c":"\u4337",
"\u7d2e":"\u624e",
"\u7d30":"\u7ec6",
"\u7d31":"\u7ec2",
"\u7d32":"\u7ec1",
"\u7d33":"\u7ec5",
"\u7d39":"\u7ecd",
"\u7d3a":"\u7ec0",
"\u7d3c":"\u7ecb",
"\u7d3f":"\u7ed0",
"\u7d40":"\u7ecc",
"\u7d42":"\u7ec8",
"\u7d43":"\u5f26",
"\u7d44":"\u7ec4",
"\u7d46":"\u7eca",
"\u7d4e":"\u7ed7",
"\u7d50":"\u7ed3",
"\u7d55":"\u7edd",
"\u7d5b":"\u7ee6",
"\u7d5d":"\u7ed4",
"\u7d5e":"\u7ede",
"\u7d61":"\u7edc",
"\u7d62":"\u7eda",
"\u7d66":"\u7ed9",
"\u7d68":"\u7ed2",
"\u7d70":"\u7ed6",
"\u7d71":"\u7edf",
"\u7d72":"\u4e1d",
"\u7d73":"\u7edb",
"\u7d79":"\u7ee2",
"\u7d81":"\u7ed1",
"\u7d83":"\u7ee1",
"\u7d86":"\u7ee0",
"\u7d88":"\u7ee8",
"\u7d8f":"\u7ee5",
"\u7d91":"\u6346",
"\u7d93":"\u7ecf",
"\u7d9c":"\u7efc",
"\u7d9e":"\u7f0d",
"\u7da0":"\u7eff",
"\u7da2":"\u7ef8",
"\u7da3":"\u7efb",
"\u7dab":"\u7ebf",
"\u7dac":"\u7ef6",
"\u7dad":"\u7ef4",
"\u7db0":"\u7efe",
"\u7db1":"\u7eb2",
"\u7db2":"\u7f51",
"\u7db4":"\u7f00",
"\u7db5":"\u5f69",
"\u7db8":"\u7eb6",
"\u7db9":"\u7efa",
"\u7dba":"\u7eee",
"\u7dbb":"\u7efd",
"\u7dbd":"\u7ef0",
"\u7dbe":"\u7eeb",
"\u7dbf":"\u7ef5",
"\u7dc4":"\u7ef2",
"\u7dc7":"\u7f01",
"\u7dca":"\u7d27",
"\u7dcb":"\u7eef",
"\u7dd2":"\u7eea",
"\u7dd4":"\u7ef1",
"\u7dd7":"\u7f03",
"\u7dd8":"\u7f04",
"\u7dd9":"\u7f02",
"\u7dda":"\u7ebf",
"\u7ddd":"\u7f09",
"\u7dde":"\u7f0e",
"\u7de0":"\u7f14",
"\u7de1":"\u7f17",
"\u7de3":"\u7f18",
"\u7de6":"\u7f0c",
"\u7de8":"\u7f16",
"\u7de9":"\u7f13",
"\u7dec":"\u7f05",
"\u7def":"\u7eac",
"\u7df1":"\u7f11",
"\u7df2":"\u7f08",
"\u7df4":"\u7ec3",
"\u7df6":"\u7f0f",
"\u7df9":"\u7f07",
"\u7dfb":"\u81f4",
"\u7e08":"\u8426",
"\u7e09":"\u7f19",
"\u7e0a":"\u7f22",
"\u7e0b":"\u7f12",
"\u7e10":"\u7ec9",
"\u7e11":"\u7f23",
"\u7e15":"\u7f0a",
"\u7e17":"\u7f1e",
"\u7e1a":"\u7ee6",
"\u7e1b":"\u7f1a",
"\u7e1d":"\u7f1c",
"\u7e1e":"\u7f1f",
"\u7e1f":"\u7f1b",
"\u7e23":"\u53bf",
"\u7e2b":"\u7f1d",
"\u7e2d":"\u7f21",
"\u7e2e":"\u7f29",
"\u7e2f":"\u6f14",
"\u7e31":"\u7eb5",
"\u7e32":"\u7f27",
"\u7e33":"\u7f1a",
"\u7e34":"\u7ea4",
"\u7e35":"\u7f26",
"\u7e36":"\u7d77",
"\u7e37":"\u7f15",
"\u7e39":"\u7f25",
"\u7e3d":"\u603b",
"\u7e3e":"\u7ee9",
"\u7e43":"\u7ef7",
"\u7e45":"\u7f2b",
"\u7e46":"\u7f2a",
"\u7e48":"\u8941",
"\u7e52":"\u7f2f",
"\u7e54":"\u7ec7",
"\u7e55":"\u7f2e",
"\u7e59":"\u7ffb",
"\u7e5a":"\u7f2d",
"\u7e5e":"\u7ed5",
"\u7e61":"\u7ee3",
"\u7e62":"\u7f0b",
"\u7e69":"\u7ef3",
"\u7e6a":"\u7ed8",
"\u7e6b":"\u7cfb",
"\u7e6d":"\u8327",
"\u7e6f":"\u7f33",
"\u7e70":"\u7f32",
"\u7e73":"\u7f34",
"\u7e79":"\u7ece",
"\u7e7c":"\u7ee7",
"\u7e7d":"\u7f24",
"\u7e7e":"\u7f31",
"\u7e88":"\u7f2c",
"\u7e8a":"\u7ea9",
"\u7e8c":"\u7eed",
"\u7e8d":"\u7d2f",
"\u7e8f":"\u7f20",
"\u7e93":"\u7f28",
"\u7e94":"\u624d",
"\u7e96":"\u7ea4",
"\u7e98":"\u7f35",
"\u7e9c":"\u7f06",
"\u7f3d":"\u94b5",
"\u7f3e":"\u74f6",
"\u7f48":"\u575b",
"\u7f4c":"\u7f42",
"\u7f66":"\u7f58",
"\u7f70":"\u7f5a",
"\u7f75":"\u9a82",
"\u7f77":"\u7f62",
"\u7f85":"\u7f57",
"\u7f86":"\u7f74",
"\u7f88":"\u7f81",
"\u7f8b":"\u8288",
"\u7fa5":"\u7f9f",
"\u7fa8":"\u7fa1",
"\u7fa9":"\u4e49",
"\u7fb6":"\u81bb",
"\u7fd2":"\u4e60",
"\u7fec":"\u7fda",
"\u7ff9":"\u7fd8",
"\u8011":"\u7aef",
"\u8021":"\u52a9",
"\u8024":"\u85c9",
"\u802c":"\u8027",
"\u802e":"\u8022",
"\u8056":"\u5723",
"\u805e":"\u95fb",
"\u806f":"\u8054",
"\u8070":"\u806a",
"\u8072":"\u58f0",
"\u8073":"\u8038",
"\u8075":"\u8069",
"\u8076":"\u8042",
"\u8077":"\u804c",
"\u8079":"\u804d",
"\u807d":"\u542c",
"\u807e":"\u804b",
"\u8085":"\u8083",
"\u808f":"\u64cd",
"\u8090":"\u80f3",
"\u80c7":"\u80ba",
"\u80ca":"\u6710",
"\u8105":"\u80c1",
"\u8108":"\u8109",
"\u811b":"\u80eb",
"\u8123":"\u5507",
"\u8129":"\u4fee",
"\u812b":"\u8131",
"\u8139":"\u80c0",
"\u814e":"\u80be",
"\u8156":"\u80e8",
"\u8161":"\u8136",
"\u8166":"\u8111",
"\u816b":"\u80bf",
"\u8173":"\u811a",
"\u8178":"\u80a0",
"\u8183":"\u817d",
"\u8186":"\u55c9",
"\u8195":"\u8158",
"\u819a":"\u80a4",
"\u819e":"\u43dd",
"\u81a0":"\u80f6",
"\u81a9":"\u817b",
"\u81bd":"\u80c6",
"\u81be":"\u810d",
"\u81bf":"\u8113",
"\u81c9":"\u8138",
"\u81cd":"\u8110",
"\u81cf":"\u8191",
"\u81d5":"\u8198",
"\u81d8":"\u814a",
"\u81d9":"\u80ed",
"\u81da":"\u80ea",
"\u81df":"\u810f",
"\u81e0":"\u8114",
"\u81e2":"\u81dc",
"\u81e5":"\u5367",
"\u81e8":"\u4e34",
"\u81fa":"\u53f0",
"\u8207":"\u4e0e",
"\u8208":"\u5174",
"\u8209":"\u4e3e",
"\u820a":"\u65e7",
"\u820b":"\u8845",
"\u8216":"\u94fa",
"\u8259":"\u8231",
"\u8263":"\u6a79",
"\u8264":"\u8223",
"\u8266":"\u8230",
"\u826b":"\u823b",
"\u8271":"\u8270",
"\u8277":"\u8273",
"\u8278":"\u8279",
"\u82bb":"\u520d",
"\u82e7":"\u82ce",
"\u82fa":"\u8393",
"\u830d":"\u82df",
"\u8332":"\u5179",
"\u8345":"\u7b54",
"\u834a":"\u8346",
"\u8373":"\u8c46",
"\u838a":"\u5e84",
"\u8396":"\u830e",
"\u83a2":"\u835a",
"\u83a7":"\u82cb",
"\u83eb":"\u5807",
"\u83ef":"\u534e",
"\u83f4":"\u5eb5",
"\u8407":"\u82cc",
"\u840a":"\u83b1",
"\u842c":"\u4e07",
"\u8435":"\u83b4",
"\u8449":"\u53f6",
"\u8452":"\u836d",
"\u8457":"\u7740",
"\u8464":"\u836e",
"\u8466":"\u82c7",
"\u846f":"\u836f",
"\u8477":"\u8364",
"\u8490":"\u641c",
"\u8494":"\u83b3",
"\u849e":"\u8385",
"\u84bc":"\u82cd",
"\u84c0":"\u836a",
"\u84c6":"\u5e2d",
"\u84cb":"\u76d6",
"\u84ee":"\u83b2",
"\u84ef":"\u82c1",
"\u84f4":"\u83bc",
"\u84fd":"\u835c",
"\u8506":"\u83f1",
"\u8514":"\u535c",
"\u851e":"\u848c",
"\u8523":"\u848b",
"\u8525":"\u8471",
"\u8526":"\u8311",
"\u852d":"\u836b",
"\u8541":"\u8368",
"\u8546":"\u8487",
"\u854e":"\u835e",
"\u8552":"\u836c",
"\u8555":"\u83b8",
"\u8558":"\u835b",
"\u8562":"\u8489",
"\u8569":"\u8361",
"\u856a":"\u829c",
"\u856d":"\u8427",
"\u8577":"\u84e3",
"\u8588":"\u835f",
"\u858a":"\u84df",
"\u858c":"\u8297",
"\u8591":"\u59dc",
"\u8594":"\u8537",
"\u8599":"\u5243",
"\u859f":"\u83b6",
"\u85a6":"\u8350",
"\u85a9":"\u8428",
"\u85ba":"\u8360",
"\u85cd":"\u84dd",
"\u85ce":"\u8369",
"\u85dd":"\u827a",
"\u85e5":"\u836f",
"\u85ea":"\u85ae",
"\u85ed":"\u44d6",
"\u85f6":"\u82c8",
"\u85f7":"\u85af",
"\u85f9":"\u853c",
"\u85fa":"\u853a",
"\u8600":"\u841a",
"\u8604":"\u8572",
"\u8606":"\u82a6",
"\u8607":"\u82cf",
"\u860a":"\u8574",
"\u860b":"\u82f9",
"\u8617":"\u8616",
"\u861a":"\u85d3",
"\u861e":"\u8539",
"\u8622":"\u830f",
"\u862d":"\u5170",
"\u863a":"\u84e0",
"\u863f":"\u841d",
"\u8655":"\u5904",
"\u8656":"\u547c",
"\u865b":"\u865a",
"\u865c":"\u864f",
"\u865f":"\u53f7",
"\u8667":"\u4e8f",
"\u866f":"\u866c",
"\u86fa":"\u86f1",
"\u86fb":"\u8715",
"\u8706":"\u86ac",
"\u873a":"\u9713",
"\u8755":"\u8680",
"\u875f":"\u732c",
"\u8766":"\u867e",
"\u8768":"\u8671",
"\u8778":"\u8717",
"\u8784":"\u86f3",
"\u879e":"\u8682",
"\u87a2":"\u8424",
"\u87bb":"\u877c",
"\u87c4":"\u86f0",
"\u87c8":"\u8748",
"\u87ce":"\u87a8",
"\u87e3":"\u866e",
"\u87ec":"\u8749",
"\u87ef":"\u86f2",
"\u87f2":"\u866b",
"\u87f6":"\u86cf",
"\u87fa":"\u87ee",
"\u87fb":"\u8681",
"\u8805":"\u8747",
"\u8806":"\u867f",
"\u880d":"\u874e",
"\u8810":"\u86f4",
"\u8811":"\u877e",
"\u8814":"\u869d",
"\u881f":"\u8721",
"\u8823":"\u86ce",
"\u8828":"\u87cf",
"\u8831":"\u86ca",
"\u8836":"\u8695",
"\u8837":"\u883c",
"\u883b":"\u86ee",
"\u8846":"\u4f17",
"\u884a":"\u8511",
"\u8852":"\u70ab",
"\u8853":"\u672f",
"\u885a":"\u80e1",
"\u885b":"\u536b",
"\u885d":"\u51b2",
"\u8879":"\u53ea",
"\u889e":"\u886e",
"\u88aa":"\u795b",
"\u88ca":"\u8885",
"\u88cf":"\u91cc",
"\u88dc":"\u8865",
"\u88dd":"\u88c5",
"\u88e1":"\u91cc",
"\u88fd":"\u5236",
"\u8907":"\u590d",
"\u890e":"\u8896",
"\u8932":"\u88e4",
"\u8933":"\u88e2",
"\u8938":"\u891b",
"\u893b":"\u4eb5",
"\u8949":"\u88e5",
"\u8956":"\u8884",
"\u895d":"\u88e3",
"\u8960":"\u88c6",
"\u8964":"\u8934",
"\u896a":"\u889c",
"\u896c":"\u6446",
"\u896f":"\u886c",
"\u8972":"\u88ad",
"\u897e":"\u897f",
"\u8988":"\u6838",
"\u898b":"\u89c1",
"\u898e":"\u89c3",
"\u898f":"\u89c4",
"\u8993":"\u89c5",
"\u8996":"\u89c6",
"\u8998":"\u89c7",
"\u899c":"\u773a",
"\u89a1":"\u89cb",
"\u89a6":"\u89ce",
"\u89aa":"\u4eb2",
"\u89ac":"\u89ca",
"\u89af":"\u89cf",
"\u89b2":"\u89d0",
"\u89b7":"\u89d1",
"\u89ba":"\u89c9",
"\u89bd":"\u89c8",
"\u89bf":"\u89cc",
"\u89c0":"\u89c2",
"\u89d4":"\u7b4b",
"\u89dd":"\u62b5",
"\u89f4":"\u89de",
"\u89f6":"\u89ef",
"\u89f8":"\u89e6",
"\u8a02":"\u8ba2",
"\u8a03":"\u8ba3",
"\u8a08":"\u8ba1",
"\u8a0a":"\u8baf",
"\u8a0c":"\u8ba7",
"\u8a0e":"\u8ba8",
"\u8a10":"\u8ba6",
"\u8a13":"\u8bad",
"\u8a15":"\u8baa",
"\u8a16":"\u8bab",
"\u8a17":"\u6258",
"\u8a18":"\u8bb0",
"\u8a1b":"\u8bb9",
"\u8a1d":"\u8bb6",
"\u8a1f":"\u8bbc",
"\u8a22":"\u6b23",
"\u8a23":"\u8bc0",
"\u8a25":"\u8bb7",
"\u8a29":"\u8bbb",
"\u8a2a":"\u8bbf",
"\u8a2d":"\u8bbe",
"\u8a31":"\u8bb8",
"\u8a34":"\u8bc9",
"\u8a36":"\u8bc3",
"\u8a3a":"\u8bca",
"\u8a3b":"\u6ce8",
"\u8a3c":"\u8bc1",
"\u8a41":"\u8bc2",
"\u8a46":"\u8bcb",
"\u8a4e":"\u8bb5",
"\u8a50":"\u8bc8",
"\u8a52":"\u8bd2",
"\u8a54":"\u8bcf",
"\u8a55":"\u8bc4",
"\u8a57":"\u8bc7",
"\u8a58":"\u8bce",
"\u8a5b":"\u8bc5",
"\u8a5e":"\u8bcd",
"\u8a60":"\u548f",
"\u8a61":"\u8be9",
"\u8a62":"\u8be2",
"\u8a63":"\u8be3",
"\u8a66":"\u8bd5",
"\u8a69":"\u8bd7",
"\u8a6b":"\u8be7",
"\u8a6c":"\u8bdf",
"\u8a6d":"\u8be1",
"\u8a6e":"\u8be0",
"\u8a70":"\u8bd8",
"\u8a71":"\u8bdd",
"\u8a72":"\u8be5",
"\u8a73":"\u8be6",
"\u8a75":"\u8bdc",
"\u8a76":"\u916c",
"\u8a7b":"\u54af",
"\u8a7c":"\u8bd9",
"\u8a7f":"\u8bd6",
"\u8a84":"\u8bd4",
"\u8a85":"\u8bdb",
"\u8a86":"\u8bd3",
"\u8a87":"\u5938",
"\u8a8c":"\u5fd7",
"\u8a8d":"\u8ba4",
"\u8a91":"\u8bf3",
"\u8a92":"\u8bf6",
"\u8a95":"\u8bde",
"\u8a98":"\u8bf1",
"\u8a9a":"\u8bee",
"\u8a9e":"\u8bed",
"\u8aa0":"\u8bda",
"\u8aa1":"\u8beb",
"\u8aa3":"\u8bec",
"\u8aa4":"\u8bef",
"\u8aa5":"\u8bf0",
"\u8aa6":"\u8bf5",
"\u8aa8":"\u8bf2",
"\u8aaa":"\u8bf4",
"\u8aac":"\u8bf4",
"\u8ab0":"\u8c01",
"\u8ab2":"\u8bfe",
"\u8ab6":"\u8c07",
"\u8ab9":"\u8bfd",
"\u8abc":"\u8c0a",
"\u8abf":"\u8c03",
"\u8ac2":"\u8c04",
"\u8ac4":"\u8c06",
"\u8ac7":"\u8c08",
"\u8ac9":"\u8bff",
"\u8acb":"\u8bf7",
"\u8acd":"\u8be4",
"\u8acf":"\u8bf9",
"\u8ad1":"\u8bfc",
"\u8ad2":"\u8c05",
"\u8ad6":"\u8bba",
"\u8ad7":"\u8c02",
"\u8adb":"\u8c00",
"\u8adc":"\u8c0d",
"\u8add":"\u8c1e",
"\u8ade":"\u8c1d",
"\u8ae0":"\u55a7",
"\u8ae2":"\u8be8",
"\u8ae4":"\u8c14",
"\u8ae6":"\u8c1b",
"\u8ae7":"\u8c10",
"\u8aeb":"\u8c0f",
"\u8aed":"\u8c15",
"\u8aee":"\u8c18",
"\u8af1":"\u8bb3",
"\u8af3":"\u8c19",
"\u8af6":"\u8c0c",
"\u8af7":"\u8bbd",
"\u8af8":"\u8bf8",
"\u8afa":"\u8c1a",
"\u8afc":"\u8c16",
"\u8afe":"\u8bfa",
"\u8b00":"\u8c0b",
"\u8b01":"\u8c12",
"\u8b02":"\u8c13",
"\u8b04":"\u8a8a",
"\u8b05":"\u8bcc",
"\u8b0a":"\u8c0e",
"\u8b0e":"\u8c1c",
"\u8b10":"\u8c27",
"\u8b14":"\u8c11",
"\u8b16":"\u8c21",
"\u8b17":"\u8c24",
"\u8b19":"\u8c26",
"\u8b1a":"\u8c25",
"\u8b1b":"\u8bb2",
"\u8b1d":"\u8c22",
"\u8b20":"\u8c23",
"\u8b28":"\u8c1f",
"\u8b2b":"\u8c2a",
"\u8b2c":"\u8c2c",
"\u8b33":"\u8bb4",
"\u8b39":"\u8c28",
"\u8b3c":"\u547c",
"\u8b3e":"\u8c29",
"\u8b41":"\u54d7",
"\u8b46":"\u563b",
"\u8b49":"\u8bc1",
"\u8b4e":"\u8c32",
"\u8b4f":"\u8ba5",
"\u8b54":"\u64b0",
"\u8b56":"\u8c2e",
"\u8b58":"\u8bc6",
"\u8b59":"\u8c2f",
"\u8b5a":"\u8c2d",
"\u8b5c":"\u8c31",
"\u8b5f":"\u566a",
"\u8b6b":"\u8c35",
"\u8b6d":"\u6bc1",
"\u8b6f":"\u8bd1",
"\u8b70":"\u8bae",
"\u8b74":"\u8c34",
"\u8b77":"\u62a4",
"\u8b7d":"\u8a89",
"\u8b7e":"\u8c2b",
"\u8b80":"\u8bfb",
"\u8b85":"\u8c09",
"\u8b8a":"\u53d8",
"\u8b8c":"\u5bb4",
"\u8b8e":"\u96e0",
"\u8b92":"\u8c17",
"\u8b93":"\u8ba9",
"\u8b95":"\u8c30",
"\u8b96":"\u8c36",
"\u8b9a":"\u8d5e",
"\u8b9c":"\u8c20",
"\u8b9e":"\u8c33",
"\u8c3f":"\u6eaa",
"\u8c48":"\u5c82",
"\u8c4e":"\u7ad6",
"\u8c50":"\u4e30",
"\u8c54":"\u8273",
"\u8c56":"\u4e8d",
"\u8c6c":"\u732a",
"\u8c76":"\u8c6e",
"\u8c8d":"\u72f8",
"\u8c93":"\u732b",
"\u8c9d":"\u8d1d",
"\u8c9e":"\u8d1e",
"\u8ca0":"\u8d1f",
"\u8ca1":"\u8d22",
"\u8ca2":"\u8d21",
"\u8ca7":"\u8d2b",
"\u8ca8":"\u8d27",
"\u8ca9":"\u8d29",
"\u8caa":"\u8d2a",
"\u8cab":"\u8d2f",
"\u8cac":"\u8d23",
"\u8caf":"\u8d2e",
"\u8cb0":"\u8d33",
"\u8cb2":"\u8d40",
"\u8cb3":"\u8d30",
"\u8cb4":"\u8d35",
"\u8cb6":"\u8d2c",
"\u8cb7":"\u4e70",
"\u8cb8":"\u8d37",
"\u8cba":"\u8d36",
"\u8cbb":"\u8d39",
"\u8cbc":"\u8d34",
"\u8cbd":"\u8d3b",
"\u8cbf":"\u8d38",
"\u8cc0":"\u8d3a",
"\u8cc1":"\u8d32",
"\u8cc2":"\u8d42",
"\u8cc3":"\u8d41",
"\u8cc4":"\u8d3f",
"\u8cc5":"\u8d45",
"\u8cc7":"\u8d44",
"\u8cc8":"\u8d3e",
"\u8cca":"\u8d3c",
"\u8cd1":"\u8d48",
"\u8cd2":"\u8d4a",
"\u8cd3":"\u5bbe",
"\u8cd5":"\u8d47",
"\u8cd9":"\u8d52",
"\u8cda":"\u8d49",
"\u8cdc":"\u8d50",
"\u8cde":"\u8d4f",
"\u8ce0":"\u8d54",
"\u8ce1":"\u8d53",
"\u8ce2":"\u8d24",
"\u8ce3":"\u5356",
"\u8ce4":"\u8d31",
"\u8ce6":"\u8d4b",
"\u8ce7":"\u8d55",
"\u8cea":"\u8d28",
"\u8cec":"\u8d26",
"\u8ced":"\u8d4c",
"\u8cf4":"\u8d56",
"\u8cf5":"\u8d57",
"\u8cf8":"\u5269",
"\u8cfa":"\u8d5a",
"\u8cfb":"\u8d59",
"\u8cfc":"\u8d2d",
"\u8cfd":"\u8d5b",
"\u8cfe":"\u8d5c",
"\u8d04":"\u8d3d",
"\u8d05":"\u8d58",
"\u8d08":"\u8d60",
"\u8d0a":"\u8d5e",
"\u8d0b":"\u8d5d",
"\u8d0d":"\u8d61",
"\u8d0f":"\u8d62",
"\u8d10":"\u8d46",
"\u8d13":"\u8d43",
"\u8d16":"\u8d4e",
"\u8d1b":"\u8d63",
"\u8d95":"\u8d76",
"\u8d99":"\u8d75",
"\u8da8":"\u8d8b",
"\u8db2":"\u8db1",
"\u8de1":"\u8ff9",
"\u8dfc":"\u5c40",
"\u8e10":"\u8df5",
"\u8e21":"\u8737",
"\u8e2b":"\u78b0",
"\u8e30":"\u903e",
"\u8e34":"\u8e0a",
"\u8e4c":"\u8dc4",
"\u8e55":"\u8df8",
"\u8e5f":"\u8ff9",
"\u8e60":"\u8dd6",
"\u8e63":"\u8e52",
"\u8e64":"\u8e2a",
"\u8e67":"\u7cdf",
"\u8e7a":"\u8df7",
"\u8e89":"\u8db8",
"\u8e8a":"\u8e0c",
"\u8e8b":"\u8dfb",
"\u8e8d":"\u8dc3",
"\u8e91":"\u8e2f",
"\u8e92":"\u8dde",
"\u8e93":"\u8e2c",
"\u8e95":"\u8e70",
"\u8e9a":"\u8df9",
"\u8ea1":"\u8e51",
"\u8ea5":"\u8e7f",
"\u8ea6":"\u8e9c",
"\u8eaa":"\u8e8f",
"\u8ec0":"\u8eaf",
"\u8eca":"\u8f66",
"\u8ecb":"\u8f67",
"\u8ecc":"\u8f68",
"\u8ecd":"\u519b",
"\u8ed2":"\u8f69",
"\u8ed4":"\u8f6b",
"\u8edb":"\u8f6d",
"\u8edf":"\u8f6f",
"\u8ee4":"\u8f77",
"\u8eeb":"\u8f78",
"\u8ef2":"\u8f71",
"\u8ef8":"\u8f74",
"\u8ef9":"\u8f75",
"\u8efa":"\u8f7a",
"\u8efb":"\u8f72",
"\u8efc":"\u8f76",
"\u8efe":"\u8f7c",
"\u8f03":"\u8f83",
"\u8f05":"\u8f82",
"\u8f07":"\u8f81",
"\u8f09":"\u8f7d",
"\u8f0a":"\u8f7e",
"\u8f12":"\u8f84",
"\u8f13":"\u633d",
"\u8f14":"\u8f85",
"\u8f15":"\u8f7b",
"\u8f1b":"\u8f86",
"\u8f1c":"\u8f8e",
"\u8f1d":"\u8f89",
"\u8f1e":"\u8f8b",
"\u8f1f":"\u8f8d",
"\u8f25":"\u8f8a",
"\u8f26":"\u8f87",
"\u8f29":"\u8f88",
"\u8f2a":"\u8f6e",
"\u8f2f":"\u8f91",
"\u8f33":"\u8f8f",
"\u8f38":"\u8f93",
"\u8f3b":"\u8f90",
"\u8f3e":"\u8f97",
"\u8f3f":"\u8206",
"\u8f42":"\u6bc2",
"\u8f44":"\u8f96",
"\u8f45":"\u8f95",
"\u8f46":"\u8f98",
"\u8f49":"\u8f6c",
"\u8f4d":"\u8f99",
"\u8f4e":"\u8f7f",
"\u8f54":"\u8f9a",
"\u8f5f":"\u8f70",
"\u8f61":"\u8f94",
"\u8f62":"\u8f79",
"\u8f64":"\u8f73",
"\u8fa6":"\u529e",
"\u8fad":"\u8f9e",
"\u8fae":"\u8fab",
"\u8faf":"\u8fa9",
"\u8fb2":"\u519c",
"\u8fc6":"\u8fe4",
"\u8ff4":"\u56de",
"\u8ffa":"\u4e43",
"\u9015":"\u8ff3",
"\u9019":"\u8fd9",
"\u9023":"\u8fde",
"\u9031":"\u5468",
"\u9032":"\u8fdb",
"\u904a":"\u6e38",
"\u904b":"\u8fd0",
"\u904e":"\u8fc7",
"\u9054":"\u8fbe",
"\u9055":"\u8fdd",
"\u9059":"\u9065",
"\u905c":"\u900a",
"\u905e":"\u9012",
"\u9060":"\u8fdc",
"\u9069":"\u9002",
"\u9072":"\u8fdf",
"\u9077":"\u8fc1",
"\u9078":"\u9009",
"\u907a":"\u9057",
"\u907c":"\u8fbd",
"\u9081":"\u8fc8",
"\u9084":"\u8fd8",
"\u9087":"\u8fe9",
"\u908a":"\u8fb9",
"\u908f":"\u903b",
"\u9090":"\u9026",
"\u90df":"\u90cf",
"\u90f5":"\u90ae",
"\u9106":"\u90d3",
"\u9109":"\u4e61",
"\u9112":"\u90b9",
"\u9114":"\u90ac",
"\u9116":"\u90e7",
"\u9127":"\u9093",
"\u912d":"\u90d1",
"\u9130":"\u90bb",
"\u9132":"\u90f8",
"\u9134":"\u90ba",
"\u9136":"\u90d0",
"\u913a":"\u909d",
"\u9148":"\u90e6",
"\u9156":"\u9e29",
"\u9183":"\u814c",
"\u9186":"\u76cf",
"\u919c":"\u4e11",
"\u919e":"\u915d",
"\u91ab":"\u533b",
"\u91ac":"\u9171",
"\u91b1":"\u53d1",
"\u91bc":"\u5bb4",
"\u91c0":"\u917f",
"\u91c1":"\u8845",
"\u91c3":"\u917e",
"\u91c5":"\u917d",
"\u91c6":"\u91c7",
"\u91cb":"\u91ca",
"\u91d0":"\u5398",
"\u91d3":"\u9486",
"\u91d4":"\u9487",
"\u91d5":"\u948c",
"\u91d7":"\u948a",
"\u91d8":"\u9489",
"\u91d9":"\u948b",
"\u91dd":"\u9488",
"\u91e3":"\u9493",
"\u91e4":"\u9490",
"\u91e6":"\u6263",
"\u91e7":"\u948f",
"\u91e9":"\u9492",
"\u91f5":"\u9497",
"\u91f7":"\u948d",
"\u91f9":"\u9495",
"\u91fa":"\u948e",
"\u91fe":"\u497a",
"\u9200":"\u94af",
"\u9201":"\u94ab",
"\u9203":"\u9498",
"\u9204":"\u94ad",
"\u9208":"\u949a",
"\u9209":"\u94a0",
"\u920d":"\u949d",
"\u9210":"\u94a4",
"\u9211":"\u94a3",
"\u9214":"\u949e",
"\u9215":"\u94ae",
"\u921e":"\u94a7",
"\u9223":"\u9499",
"\u9225":"\u94ac",
"\u9226":"\u949b",
"\u9227":"\u94aa",
"\u922e":"\u94cc",
"\u9230":"\u94c8",
"\u9233":"\u94b6",
"\u9234":"\u94c3",
"\u9237":"\u94b4",
"\u9238":"\u94b9",
"\u9239":"\u94cd",
"\u923a":"\u94b0",
"\u923d":"\u94b8",
"\u923e":"\u94c0",
"\u923f":"\u94bf",
"\u9240":"\u94be",
"\u9245":"\u949c",
"\u9246":"\u94bb",
"\u9248":"\u94ca",
"\u9249":"\u94c9",
"\u924b":"\u5228",
"\u924d":"\u94cb",
"\u9251":"\u94c2",
"\u9255":"\u94b7",
"\u9257":"\u94b3",
"\u925a":"\u94c6",
"\u925b":"\u94c5",
"\u925e":"\u94ba",
"\u9262":"\u94b5",
"\u9264":"\u94a9",
"\u9266":"\u94b2",
"\u926c":"\u94bc",
"\u926d":"\u94bd",
"\u9276":"\u94cf",
"\u9278":"\u94f0",
"\u927a":"\u94d2",
"\u927b":"\u94ec",
"\u927f":"\u94ea",
"\u9280":"\u94f6",
"\u9283":"\u94f3",
"\u9285":"\u94dc",
"\u9291":"\u94e3",
"\u9293":"\u94e8",
"\u9296":"\u94e2",
"\u9298":"\u94ed",
"\u929a":"\u94eb",
"\u929c":"\u8854",
"\u92a0":"\u94d1",
"\u92a3":"\u94f7",
"\u92a5":"\u94f1",
"\u92a6":"\u94df",
"\u92a8":"\u94f5",
"\u92a9":"\u94e5",
"\u92aa":"\u94d5",
"\u92ab":"\u94ef",
"\u92ac":"\u94d0",
"\u92b1":"\u94de",
"\u92b2":"\u710a",
"\u92b3":"\u9510",
"\u92b7":"\u9500",
"\u92b9":"\u9508",
"\u92bb":"\u9511",
"\u92bc":"\u9509",
"\u92c1":"\u94dd",
"\u92c3":"\u9512",
"\u92c5":"\u950c",
"\u92c7":"\u94a1",
"\u92cc":"\u94e4",
"\u92cf":"\u94d7",
"\u92d2":"\u950b",
"\u92dd":"\u950a",
"\u92df":"\u9513",
"\u92e3":"\u94d8",
"\u92e4":"\u9504",
"\u92e5":"\u9503",
"\u92e6":"\u9514",
"\u92e8":"\u9507",
"\u92e9":"\u94d3",
"\u92ea":"\u94fa",
"\u92ee":"\u94d6",
"\u92ef":"\u9506",
"\u92f0":"\u9502",
"\u92f1":"\u94fd",
"\u92f6":"\u950d",
"\u92f8":"\u952f",
"\u92fb":"\u9274",
"\u92fc":"\u94a2",
"\u9301":"\u951e",
"\u9304":"\u5f55",
"\u9306":"\u9516",
"\u9307":"\u952b",
"\u9308":"\u9529",
"\u9310":"\u9525",
"\u9312":"\u9515",
"\u9315":"\u951f",
"\u9318":"\u9524",
"\u9319":"\u9531",
"\u931a":"\u94ee",
"\u931b":"\u951b",
"\u931f":"\u952c",
"\u9320":"\u952d",
"\u9322":"\u94b1",
"\u9326":"\u9526",
"\u9328":"\u951a",
"\u932b":"\u9521",
"\u932e":"\u9522",
"\u932f":"\u9519",
"\u9333":"\u9530",
"\u9336":"\u8868",
"\u9338":"\u94fc",
"\u9340":"\u951d",
"\u9341":"\u9528",
"\u9343":"\u952a",
"\u9346":"\u9494",
"\u9347":"\u9534",
"\u934a":"\u70bc",
"\u934b":"\u9505",
"\u934d":"\u9540",
"\u9354":"\u9537",
"\u9358":"\u94e1",
"\u935a":"\u9496",
"\u935b":"\u953b",
"\u9364":"\u9538",
"\u9365":"\u9532",
"\u9369":"\u9518",
"\u936c":"\u9539",
"\u9370":"\u953e",
"\u9375":"\u952e",
"\u9376":"\u9536",
"\u937a":"\u9517",
"\u937c":"\u9488",
"\u937e":"\u949f",
"\u9382":"\u9541",
"\u9384":"\u953f",
"\u9387":"\u9545",
"\u938a":"\u9551",
"\u938c":"\u9570",
"\u9394":"\u9555",
"\u9396":"\u9501",
"\u9397":"\u67aa",
"\u9398":"\u9549",
"\u939a":"\u9524",
"\u93a1":"\u9543",
"\u93a2":"\u94a8",
"\u93a3":"\u84e5",
"\u93a6":"\u954f",
"\u93a7":"\u94e0",
"\u93a9":"\u94e9",
"\u93aa":"\u953c",
"\u93ac":"\u9550",
"\u93ae":"\u9547",
"\u93b0":"\u9552",
"\u93b3":"\u954d",
"\u93b5":"\u9553",
"\u93bf":"\u954e",
"\u93c3":"\u955e",
"\u93c7":"\u955f",
"\u93c8":"\u94fe",
"\u93cc":"\u9546",
"\u93cd":"\u9559",
"\u93d1":"\u955d",
"\u93d7":"\u94ff",
"\u93d8":"\u9535",
"\u93dc":"\u9557",
"\u93dd":"\u9558",
"\u93de":"\u955b",
"\u93df":"\u94f2",
"\u93e1":"\u955c",
"\u93e2":"\u9556",
"\u93e4":"\u9542",
"\u93e8":"\u933e",
"\u93f0":"\u955a",
"\u93f5":"\u94e7",
"\u93f7":"\u9564",
"\u93f9":"\u956a",
"\u93fa":"\u497d",
"\u93fd":"\u9508",
"\u9403":"\u94d9",
"\u9409":"\u94e3",
"\u940b":"\u94f4",
"\u9410":"\u9563",
"\u9412":"\u94f9",
"\u9413":"\u9566",
"\u9414":"\u9561",
"\u9418":"\u949f",
"\u9419":"\u956b",
"\u941d":"\u9562",
"\u9420":"\u9568",
"\u9425":"\u4985",
"\u9426":"\u950e",
"\u9427":"\u950f",
"\u9428":"\u9544",
"\u942b":"\u954c",
"\u942e":"\u9570",
"\u942f":"\u4983",
"\u9432":"\u956f",
"\u9433":"\u956d",
"\u9435":"\u94c1",
"\u9436":"\u956e",
"\u9438":"\u94ce",
"\u943a":"\u94db",
"\u943f":"\u9571",
"\u9444":"\u94f8",
"\u944a":"\u956c",
"\u944c":"\u9554",
"\u9451":"\u9274",
"\u9452":"\u9274",
"\u9454":"\u9572",
"\u9455":"\u9527",
"\u945e":"\u9574",
"\u9460":"\u94c4",
"\u9463":"\u9573",
"\u9464":"\u5228",
"\u9465":"\u9565",
"\u946a":"\u7089",
"\u946d":"\u9567",
"\u9470":"\u94a5",
"\u9472":"\u9576",
"\u9475":"\u7f50",
"\u9477":"\u954a",
"\u9479":"\u9569",
"\u947c":"\u9523",
"\u947d":"\u94bb",
"\u947e":"\u92ae",
"\u947f":"\u51ff",
"\u9481":"\u4986",
"\u9482":"\u954b",
"\u9577":"\u957f",
"\u9580":"\u95e8",
"\u9582":"\u95e9",
"\u9583":"\u95ea",
"\u9586":"\u95eb",
"\u9589":"\u95ed",
"\u958b":"\u5f00",
"\u958c":"\u95f6",
"\u958e":"\u95f3",
"\u958f":"\u95f0",
"\u9591":"\u95f2",
"\u9592":"\u95f2",
"\u9593":"\u95f4",
"\u9594":"\u95f5",
"\u9598":"\u95f8",
"\u95a1":"\u9602",
"\u95a3":"\u9601",
"\u95a4":"\u5408",
"\u95a5":"\u9600",
"\u95a8":"\u95fa",
"\u95a9":"\u95fd",
"\u95ab":"\u9603",
"\u95ac":"\u9606",
"\u95ad":"\u95fe",
"\u95b1":"\u9605",
"\u95b6":"\u960a",
"\u95b9":"\u9609",
"\u95bb":"\u960e",
"\u95bc":"\u960f",
"\u95bd":"\u960d",
"\u95be":"\u9608",
"\u95bf":"\u960c",
"\u95c3":"\u9612",
"\u95c6":"\u677f",
"\u95c7":"\u6697",
"\u95c8":"\u95f1",
"\u95ca":"\u9614",
"\u95cb":"\u9615",
"\u95cc":"\u9611",
"\u95d0":"\u9617",
"\u95d3":"\u95ff",
"\u95d4":"\u9616",
"\u95d5":"\u9619",
"\u95d6":"\u95ef",
"\u95dc":"\u5173",
"\u95de":"\u961a",
"\u95e1":"\u9610",
"\u95e2":"\u8f9f",
"\u95e5":"\u95fc",
"\u9628":"\u5384",
"\u962c":"\u5751",
"\u962f":"\u5740",
"\u964f":"\u968b",
"\u9658":"\u9649",
"\u965d":"\u9655",
"\u965e":"\u5347",
"\u9663":"\u9635",
"\u9670":"\u9634",
"\u9673":"\u9648",
"\u9678":"\u9646",
"\u967d":"\u9633",
"\u9684":"\u5824",
"\u9689":"\u9667",
"\u968a":"\u961f",
"\u968e":"\u9636",
"\u9695":"\u9668",
"\u969b":"\u9645",
"\u96a4":"\u9893",
"\u96a8":"\u968f",
"\u96aa":"\u9669",
"\u96b1":"\u9690",
"\u96b4":"\u9647",
"\u96b8":"\u96b6",
"\u96bb":"\u53ea",
"\u96cb":"\u96bd",
"\u96d6":"\u867d",
"\u96d9":"\u53cc",
"\u96db":"\u96cf",
"\u96dc":"\u6742",
"\u96de":"\u9e21",
"\u96e2":"\u79bb",
"\u96e3":"\u96be",
"\u96f2":"\u4e91",
"\u96fb":"\u7535",
"\u9724":"\u6e9c",
"\u9727":"\u96fe",
"\u973d":"\u9701",
"\u9742":"\u96f3",
"\u9744":"\u972d",
"\u9746":"\u53c7",
"\u9748":"\u7075",
"\u9749":"\u53c6",
"\u975a":"\u9753",
"\u975c":"\u9759",
"\u9766":"\u817c",
"\u9768":"\u9765",
"\u978f":"\u5de9",
"\u97a6":"\u79cb",
"\u97c1":"\u7f30",
"\u97c3":"\u9791",
"\u97c6":"\u5343",
"\u97c9":"\u97af",
"\u97cb":"\u97e6",
"\u97cc":"\u97e7",
"\u97cd":"\u97e8",
"\u97d3":"\u97e9",
"\u97d9":"\u97ea",
"\u97dc":"\u97ec",
"\u97de":"\u97eb",
"\u97fb":"\u97f5",
"\u97ff":"\u54cd",
"\u9801":"\u9875",
"\u9802":"\u9876",
"\u9803":"\u9877",
"\u9805":"\u9879",
"\u9806":"\u987a",
"\u9807":"\u9878",
"\u9808":"\u987b",
"\u980a":"\u987c",
"\u980c":"\u9882",
"\u980e":"\u9880",
"\u980f":"\u9883",
"\u9810":"\u9884",
"\u9811":"\u987d",
"\u9812":"\u9881",
"\u9813":"\u987f",
"\u9817":"\u9887",
"\u9818":"\u9886",
"\u981c":"\u988c",
"\u9821":"\u9889",
"\u9824":"\u9890",
"\u9826":"\u988f",
"\u982b":"\u4fef",
"\u982d":"\u5934",
"\u9830":"\u988a",
"\u9832":"\u988b",
"\u9837":"\u9894",
"\u9838":"\u9888",
"\u9839":"\u9893",
"\u983b":"\u9891",
"\u9846":"\u9897",
"\u984c":"\u9898",
"\u984d":"\u989d",
"\u984e":"\u816d",
"\u984f":"\u989c",
"\u9852":"\u9899",
"\u9853":"\u989b",
"\u9854":"\u989c",
"\u9858":"\u613f",
"\u9859":"\u98a1",
"\u985b":"\u98a0",
"\u985e":"\u7c7b",
"\u9862":"\u989f",
"\u9865":"\u98a2",
"\u9867":"\u987e",
"\u986b":"\u98a4",
"\u986c":"\u98a5",
"\u986f":"\u663e",
"\u9870":"\u98a6",
"\u9871":"\u9885",
"\u9873":"\u989e",
"\u9874":"\u98a7",
"\u98a8":"\u98ce",
"\u98ae":"\u98d1",
"\u98af":"\u98d2",
"\u98b1":"\u53f0",
"\u98b3":"\u522e",
"\u98b6":"\u98d3",
"\u98b8":"\u98d4",
"\u98ba":"\u626c",
"\u98bc":"\u98d5",
"\u98c0":"\u98d7",
"\u98c4":"\u98d8",
"\u98c6":"\u98d9",
"\u98c8":"\u98da",
"\u98db":"\u98de",
"\u98e2":"\u9965",
"\u98e5":"\u9966",
"\u98e9":"\u9968",
"\u98ea":"\u996a",
"\u98eb":"\u996b",
"\u98ed":"\u996c",
"\u98ef":"\u996d",
"\u98f2":"\u996e",
"\u98f4":"\u9974",
"\u98fc":"\u9972",
"\u98fd":"\u9971",
"\u98fe":"\u9970",
"\u98ff":"\u9973",
"\u9903":"\u997a",
"\u9904":"\u9978",
"\u9905":"\u997c",
"\u9908":"\u7ccd",
"\u9909":"\u9977",
"\u990a":"\u517b",
"\u990c":"\u9975",
"\u990e":"\u9979",
"\u990f":"\u997b",
"\u9911":"\u997d",
"\u9912":"\u9981",
"\u9913":"\u997f",
"\u9914":"\u54fa",
"\u9918":"\u4f59",
"\u991a":"\u80b4",
"\u991b":"\u9984",
"\u991c":"\u9983",
"\u991e":"\u996f",
"\u9921":"\u9985",
"\u9928":"\u9986",
"\u992c":"\u7cca",
"\u9931":"\u7cc7",
"\u9933":"\u9967",
"\u9935":"\u5582",
"\u9936":"\u9989",
"\u9937":"\u9987",
"\u993a":"\u998e",
"\u993c":"\u9969",
"\u993d":"\u9988",
"\u993e":"\u998f",
"\u993f":"\u998a",
"\u9943":"\u998d",
"\u9945":"\u9992",
"\u9948":"\u9990",
"\u9949":"\u9991",
"\u994a":"\u9993",
"\u994b":"\u9988",
"\u994c":"\u9994",
"\u9951":"\u9965",
"\u9952":"\u9976",
"\u9957":"\u98e8",
"\u995c":"\u990d",
"\u995e":"\u998b",
"\u995f":"\u9995",
"\u99ac":"\u9a6c",
"\u99ad":"\u9a6d",
"\u99ae":"\u51af",
"\u99b1":"\u9a6e",
"\u99b3":"\u9a70",
"\u99b4":"\u9a6f",
"\u99c1":"\u9a73",
"\u99d0":"\u9a7b",
"\u99d1":"\u9a7d",
"\u99d2":"\u9a79",
"\u99d4":"\u9a75",
"\u99d5":"\u9a7e",
"\u99d8":"\u9a80",
"\u99d9":"\u9a78",
"\u99db":"\u9a76",
"\u99dd":"\u9a7c",
"\u99df":"\u9a77",
"\u99e2":"\u9a88",
"\u99ed":"\u9a87",
"\u99ee":"\u9a73",
"\u99f1":"\u9a86",
"\u99f8":"\u9a8e",
"\u99ff":"\u9a8f",
"\u9a01":"\u9a8b",
"\u9a03":"\u5446",
"\u9a05":"\u9a93",
"\u9a0d":"\u9a92",
"\u9a0e":"\u9a91",
"\u9a0f":"\u9a90",
"\u9a16":"\u9a9b",
"\u9a19":"\u9a97",
"\u9a23":"\u9b03",
"\u9a2b":"\u9a9e",
"\u9a2d":"\u9a98",
"\u9a2e":"\u9a9d",
"\u9a30":"\u817e",
"\u9a36":"\u9a7a",
"\u9a37":"\u9a9a",
"\u9a38":"\u9a9f",
"\u9a3e":"\u9aa1",
"\u9a40":"\u84e6",
"\u9a41":"\u9a9c",
"\u9a42":"\u9a96",
"\u9a43":"\u9aa0",
"\u9a44":"\u9aa2",
"\u9a45":"\u9a71",
"\u9a4a":"\u9a85",
"\u9a4d":"\u9a81",
"\u9a4f":"\u9aa3",
"\u9a55":"\u9a84",
"\u9a57":"\u9a8c",
"\u9a5a":"\u60ca",
"\u9a5b":"\u9a7f",
"\u9a5f":"\u9aa4",
"\u9a62":"\u9a74",
"\u9a64":"\u9aa7",
"\u9a65":"\u9aa5",
"\u9a6a":"\u9a8a",
"\u9aaf":"\u80ae",
"\u9acf":"\u9ac5",
"\u9ad2":"\u810f",
"\u9ad4":"\u4f53",
"\u9ad5":"\u9acc",
"\u9ad6":"\u9acb",
"\u9ae3":"\u4eff",
"\u9aee":"\u53d1",
"\u9b06":"\u677e",
"\u9b0d":"\u80e1",
"\u9b1a":"\u987b",
"\u9b22":"\u9b13",
"\u9b25":"\u6597",
"\u9b27":"\u95f9",
"\u9b28":"\u54c4",
"\u9b29":"\u960b",
"\u9b2e":"\u9604",
"\u9b31":"\u90c1",
"\u9b4e":"\u9b49",
"\u9b58":"\u9b47",
"\u9b5a":"\u9c7c",
"\u9b5b":"\u9c7d",
"\u9b68":"\u8c5a",
"\u9b6f":"\u9c81",
"\u9b74":"\u9c82",
"\u9b77":"\u9c7f",
"\u9b81":"\u9c85",
"\u9b83":"\u9c86",
"\u9b8d":"\u9c8f",
"\u9b90":"\u9c90",
"\u9b91":"\u9c8d",
"\u9b92":"\u9c8b",
"\u9b93":"\u9c8a",
"\u9b9a":"\u9c92",
"\u9b9e":"\u9c95",
"\u9ba3":"\u4c9f",
"\u9ba6":"\u9c96",
"\u9baa":"\u9c94",
"\u9bab":"\u9c9b",
"\u9bad":"\u9c91",
"\u9bae":"\u9c9c",
"\u9bba":"\u9c9d",
"\u9bc0":"\u9ca7",
"\u9bc1":"\u9ca0",
"\u9bc7":"\u9ca9",
"\u9bc9":"\u9ca4",
"\u9bca":"\u9ca8",
"\u9bd4":"\u9cbb",
"\u9bd6":"\u9cad",
"\u9bd7":"\u9c9e",
"\u9bdb":"\u9cb7",
"\u9bdd":"\u9cb4",
"\u9be1":"\u9cb1",
"\u9be2":"\u9cb5",
"\u9be4":"\u9cb2",
"\u9be7":"\u9cb3",
"\u9be8":"\u9cb8",
"\u9bea":"\u9cae",
"\u9beb":"\u9cb0",
"\u9bf0":"\u9c87",
"\u9bf4":"\u9cba",
"\u9bfd":"\u9cab",
"\u9bff":"\u9cca",
"\u9c02":"\u9c97",
"\u9c08":"\u9cbd",
"\u9c09":"\u9cc7",
"\u9c0c":"\u4ca1",
"\u9c0d":"\u9cc5",
"\u9c12":"\u9cc6",
"\u9c13":"\u9cc3",
"\u9c1b":"\u9cc1",
"\u9c1c":"\u9cd2",
"\u9c1f":"\u9cd1",
"\u9c20":"\u9ccb",
"\u9c23":"\u9ca5",
"\u9c25":"\u9ccf",
"\u9c27":"\u4ca2",
"\u9c28":"\u9cce",
"\u9c29":"\u9cd0",
"\u9c2d":"\u9ccd",
"\u9c31":"\u9ca2",
"\u9c32":"\u9ccc",
"\u9c33":"\u9cd3",
"\u9c35":"\u9cd8",
"\u9c37":"\u9ca6",
"\u9c39":"\u9ca3",
"\u9c3b":"\u9cd7",
"\u9c3c":"\u9cdb",
"\u9c3e":"\u9cd4",
"\u9c45":"\u9cd9",
"\u9c48":"\u9cd5",
"\u9c49":"\u9cd6",
"\u9c52":"\u9cdf",
"\u9c54":"\u9cdd",
"\u9c56":"\u9cdc",
"\u9c57":"\u9cde",
"\u9c58":"\u9c9f",
"\u9c5d":"\u9cbc",
"\u9c5f":"\u9c8e",
"\u9c60":"\u9c99",
"\u9c63":"\u9ce3",
"\u9c67":"\u9ce2",
"\u9c68":"\u9cbf",
"\u9c6d":"\u9c9a",
"\u9c77":"\u9cc4",
"\u9c78":"\u9c88",
"\u9c7a":"\u9ca1",
"\u9ce5":"\u9e1f",
"\u9ce7":"\u51eb",
"\u9ce9":"\u9e20",
"\u9cf3":"\u51e4",
"\u9cf4":"\u9e23",
"\u9cf6":"\u9e22",
"\u9cfe":"\u4d13",
"\u9d06":"\u9e29",
"\u9d07":"\u9e28",
"\u9d08":"\u96c1",
"\u9d09":"\u9e26",
"\u9d12":"\u9e30",
"\u9d15":"\u9e35",
"\u9d1b":"\u9e33",
"\u9d1d":"\u9e32",
"\u9d1e":"\u9e2e",
"\u9d1f":"\u9e31",
"\u9d23":"\u9e2a",
"\u9d26":"\u9e2f",
"\u9d28":"\u9e2d",
"\u9d2f":"\u9e38",
"\u9d30":"\u9e39",
"\u9d34":"\u9e3b",
"\u9d37":"\u4d15",
"\u9d3b":"\u9e3f",
"\u9d3f":"\u9e3d",
"\u9d41":"\u4d14",
"\u9d42":"\u9e3a",
"\u9d43":"\u9e3c",
"\u9d51":"\u9e43",
"\u9d52":"\u9e46",
"\u9d53":"\u9e41",
"\u9d5c":"\u9e48",
"\u9d5d":"\u9e45",
"\u9d60":"\u9e44",
"\u9d61":"\u9e49",
"\u9d6a":"\u9e4c",
"\u9d6c":"\u9e4f",
"\u9d6e":"\u9e50",
"\u9d6f":"\u9e4e",
"\u9d70":"\u96d5",
"\u9d72":"\u9e4a",
"\u9d84":"\u4d16",
"\u9d87":"\u9e2b",
"\u9d89":"\u9e51",
"\u9d8a":"\u9e52",
"\u9d8f":"\u9e21",
"\u9d93":"\u9e4b",
"\u9d96":"\u9e59",
"\u9d98":"\u9e55",
"\u9d9a":"\u9e57",
"\u9da1":"\u9e56",
"\u9da5":"\u9e5b",
"\u9da9":"\u9e5c",
"\u9daa":"\u4d17",
"\u9dac":"\u9e27",
"\u9daf":"\u83ba",
"\u9db1":"\u9a9e",
"\u9db4":"\u9e64",
"\u9dba":"\u9e61",
"\u9dbb":"\u9e58",
"\u9dbc":"\u9e63",
"\u9dbf":"\u9e5a",
"\u9dc2":"\u9e5e",
"\u9dc9":"\u4d18",
"\u9dd3":"\u9e67",
"\u9dd6":"\u9e65",
"\u9dd7":"\u9e25",
"\u9dd9":"\u9e37",
"\u9dda":"\u9e68",
"\u9de5":"\u9e36",
"\u9de6":"\u9e6a",
"\u9def":"\u9e69",
"\u9df0":"\u71d5",
"\u9df2":"\u9e6b",
"\u9df3":"\u9e47",
"\u9df4":"\u9e47",
"\u9df8":"\u9e6c",
"\u9df9":"\u9e70",
"\u9dfa":"\u9e6d",
"\u9e07":"\u9e6f",
"\u9e0a":"\u4d19",
"\u9e0c":"\u9e71",
"\u9e15":"\u9e2c",
"\u9e1a":"\u9e66",
"\u9e1b":"\u9e73",
"\u9e1d":"\u9e42",
"\u9e1e":"\u9e3e",
"\u9e75":"\u5364",
"\u9e79":"\u54b8",
"\u9e7a":"\u9e7e",
"\u9e7c":"\u7877",
"\u9e7d":"\u76d0",
"\u9e97":"\u4e3d",
"\u9ea5":"\u9ea6",
"\u9ea9":"\u9eb8",
"\u9eb5":"\u9762",
"\u9ebc":"\u4e48",
"\u9ec3":"\u9ec4",
"\u9ecc":"\u9ec9",
"\u9ede":"\u70b9",
"\u9ee8":"\u515a",
"\u9ef2":"\u9eea",
"\u9ef4":"\u9709",
"\u9ef6":"\u9ee1",
"\u9ef7":"\u9ee9",
"\u9efd":"\u9efe",
"\u9eff":"\u9f0b",
"\u9f07":"\u9ccc",
"\u9f09":"\u9f0d",
"\u9f15":"\u51ac",
"\u9f34":"\u9f39",
"\u9f4a":"\u9f50",
"\u9f4b":"\u658b",
"\u9f4e":"\u8d4d",
"\u9f4f":"\u9f51",
"\u9f52":"\u9f7f",
"\u9f54":"\u9f80",
"\u9f59":"\u9f85",
"\u9f5c":"\u9f87",
"\u9f5f":"\u9f83",
"\u9f60":"\u9f86",
"\u9f61":"\u9f84",
"\u9f63":"\u51fa",
"\u9f66":"\u9f88",
"\u9f67":"\u556e",
"\u9f6a":"\u9f8a",
"\u9f6c":"\u9f89",
"\u9f72":"\u9f8b",
"\u9f76":"\u816d",
"\u9f77":"\u9f8c",
"\u9f8d":"\u9f99",
"\u9f90":"\u5e9e",
"\u9f91":"\u4dae",
"\u9f94":"\u9f9a",
"\u9f95":"\u9f9b",
"\u9f9c":"\u9f9f",
"\ufa0c":"\u5140",
"\ufe30":"\u2236",
"\ufe31":"\uff5c",
"\ufe33":"\uff5c",
"\ufe3f":"\u2227",
"\ufe40":"\u2228",
"\ufe50":"\uff0c",
"\ufe51":"\u3001",
"\ufe52":"\uff0e",
"\ufe54":"\uff1b",
"\ufe55":"\uff1a",
"\ufe56":"\uff1f",
"\ufe57":"\uff01",
"\ufe59":"\uff08",
"\ufe5a":"\uff09",
"\ufe5b":"\uff5b",
"\ufe5c":"\uff5d",
"\ufe5d":"\uff3b",
"\ufe5e":"\uff3d",
"\ufe5f":"\uff03",
"\ufe60":"\uff06",
"\ufe61":"\uff0a",
"\ufe62":"\uff0b",
"\ufe63":"\uff0d",
"\ufe64":"\uff1c",
"\ufe65":"\uff1e",
"\ufe66":"\uff1d",
"\ufe69":"\uff04",
"\ufe6a":"\uff05",
"\ufe6b":"\uff20",
"\u300C":"\u300C",
"\u300D":"\u300D",
};

function toSimp(itxt){
	var zhmap = TongWen.t_2_s;

	itxt = itxt.replace(/[^\x00-\xFF]/g, replaceFn);

	return itxt;

	/////
	function replaceFn(s){
		return ((s in zhmap) ? zhmap[s] : s);
	}
}

module.exports = toSimp;
